import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import Loader from "../../utils/Loader";
import { fill_action } from "../../actions/fillList_action";
import {
    companyStatusActionId,
    countryActionId,
    toastError,
    toastSuccess,
    downloadReport,
    sessionExpireMessage,
    tokenInavlidMessage, BASE_URL
} from "../../utils/constants";
import { update_additional_service_approval_action } from "../../actions/myOrders_action/myOrders_action";
import Header from "../../common_components/Header";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import SignatureCanvas from "react-signature-canvas";
import {
    client_detail_action,
} from "../../actions/master_actions/client_action";
import {
    get_additional_services_action,
    getServiceVendorPackageDetail_action,
} from "../../actions/bookingDetails_action/aditionalServices_action";

import {

    order_edit_details,
    download_no_due_action,
} from "../../actions/myOrders_action/myOrders_action";

import {
    get_possession_list_action,
    get_exist_list_action,
    insert_possession_list_action,
    insert_exist_list_action,
    send_new_pi_action,
} from "../../actions/checkList_action/checkList_action";
import { get_booking_Details_action } from "../../actions/bookingDetails_action/bookingDetails_action";
import { download_exitPass_action } from "../../actions/myOrders_action/myOrders_action";
import { event } from "jquery";
import { Button, Modal } from "react-bootstrap";

class CheckList_au extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isAccordionExpanded: false,
            followInfoCollapse: false,
            deleteShow: false,
            followUpShow: false,
            rejectShow: false,
            isEditMode: true,
            userId: "",
            OrderID: "",
            RoleID: "",
            Note: "",
            OrderNo: "",
            Date: "",
            StatusID: "",
            OrderDate: "",
            ItmeCenter: "",
            TypeOfEventID: "",
            DeliveryStatus: "",
            TypeOfEvent: "",
            EventName: "",
            grandTotal: "",
            Is_NoDue: false,
            Is_ExitPass: false,
            Is_Approved: false,
            RejectReasonID: "",
            RejectReason: "",
            RejectionNote: "",
            MyOrdersData: [],
            filteredData: [],
            eventFillList: [],
            cancellationReasonList: [],
            rejectionReasonList: [],
            //client list
            stateId: "",
            stateList: [],
            countryName: "",
            countryId: "",
            countryList: [],
            firstName: "",
            lastName: "",
            designation: "",
            companyName: "",
            addressLine1: "",
            addressLine2: "",
            cityId: "",
            cityList: [],
            pincode: "",
            Mobile1: "",
            Mobile2: "",
            primaryEmailID: "",
            secondaryEmailID: "",
            website: "",
            mobileISD1: "",
            mobileISD2: "",
            accountType: "",
            accountTypeList: [],

            SameAsAbove: false,

            SAAFirstName: "",
            SAALastName: "",
            SAADesignation: "",
            SAACompanyName: "",
            SAAAddressLine1: "",
            SAAAddressLine2: "",
            SAACityId: "",
            SAAPincode: "",
            SAAMobile1: "",
            SAAMobile2: "",
            SAAPrimaryEmailID: "",
            SAASecondaryEmailID: "",
            SAAWebsite: "",
            SAAStateId: "",
            SAACountryId: "",
            SAATelephoneNumber: "",
            SAAMobileISD1: "",
            SAAMobileISD2: "",
            SAAISD: "",
            registrationNumber: "",
            PANCardNo: "",
            NameonPANCard: "",
            GSTNo: "",
            CompanyStatus: "",
            TANNumber: "",
            UINNumber: "",
            TelephoneNumber: "",

            accountName: "",
            accountNo: "",
            accountType: "",
            bankName: "",
            branchName: "",
            IFSCCode: "",

            CityName: "",
            tempCityList: [],
            SAACityName: "",
            companyStatusId: "",
            companyStatusList: [],
            ISD: "",
            //payment
            paymentType: "",
            ToPay: "",
            isLoadPayment: false,
            encPayload: "",
            orderId: "",
            changeAmt: 1,
            paymentAccessCode: "AVVI64IL27CE56IVEC",
            finalCurrency: "",
            currencyErr: false,
            CenterID: "",
            unlistedAddServices: [],
            includedServices: [],
            externalServices: [],
            additionalServicesList: [],
            standardPremiumId: [],
            standardPremiumList: [],
            show: false,
            possessionSignatureData: "",
            isSignatureSaved: false,
            isSignatureSaveFlag: false,
            showCountryId: "",
            possessionIncludedServicesList: [],
            possessionInhouseServicesList: [],

            //Booking Details
            EntryType: "",
            TypeOfEvent: "",
            SittingArrangement: "",
            bookingList: [],
            BookingEventDataList: [],
            PossesionStartDate: "",
            PossesionEndDate: "",
            PossesionStartTime: "",
            PossesionEndTime: "",
            eventStartDate: "",
            eventEndDate: "",
            eventStartTime: "",
            eventEndTime: "",
            dismantleStartDate: "",
            dismantleEndDate: "",
            dismantleStartTime: "",
            dismantleEndTime: "",

            exitIncludedServicesList: [],
            exitInhouseServicesList: [],
            exitInstructionList: [],

            ExitSignatureData: "",
            isSignatureSaved2: false,
            isSignatureSaveFlag2: false,

            possessionDataListFlag: false,
            existDataListFlag: false,

            unlistedAddServices: '',

            noDueCertificate: '',
            isSecurityReceipt: '',
            exitPass: '',
            possessionCheckList: [],
            PossesionSubmittedUser: '',
            PossesionSubmittedDate: '',
            ExitSubmittedUser: '',
            ExitSubmittedDate: '',
            exitSub: false,
            possessionSub: false,
            possessionCheckListAllSelected: false,
            exitCheckListAllSelected: false,
            exitAddChargesWaveOff: false,
            exitAddChargesWaveOffRemark: '',
            AdditionHours: '',
            exitVendorList: [],
            possessionVendorList: [],
            preTel: '',
            AreaCode: '',
            electricityPossesion: '',
            electricityExit: 0,
            electricityExitErrMsg: '',
            PossessionContactNameAndNumber: '',
            ExitContactNameAndNumber: '',
            possessionConsumableList: [],
            exitConsumableList: [],
            SelectedExtService: [],
            possessionMaterialList: [],
            possessionMaterialNameAndServiceName: [],
            possessionSecurityList: [],
            exitMaterialList: [],
            exitMaterialNameAndServiceName: [],
            exitSecurityList: [],
            PossessionSecurityChecklistNote: '',
            ExitSecurityChecklistNote: '',
            summaryArrList: [],
            possessionTime: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString(),
            exitTime: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString(),
            FinalExitSubmit: 0,
            sortAdditionHours: 0,
            oppIsSignatureSaveFlag2: false,
            oppIsSignatureSaved2: false,
            oppExitSignatureData: '',
            ExitOperationNameContact: '',
            oppIsSignatureSaveFlag: false,
            oppIsSignatureSaved: false,
            oppPossessionSignatureData: '',
            PosssesionOperationNameContact: '',
            possServiceCheckAll: false,
            securityEmailData: {},
            additionalHrsCalculationAmount: 0,
            sumOfAddtionalQauntityAmount: 0,
            totalHrsEvent: 0,
            possessionConsumableAllSelect: false,
            exitConsumableAllSelect: false,
            isExitClientSubmitted: false,
            oldAsAmount: 0,
            piSendShow: false,
            exitPiFilePath: '',
            ProformaInvoiceID: '',
            ProformaInvoice_No: '', exitSecurityChecklistCheckAll: false,
            piFilePath: '', exitPiFilePath: '', taxInvoiceFilePath: '',
        };
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem('UserLoginData')) == null) {
            console.log('log')
            setTimeout(() => {
                this.props.navigate('/login')
            }, 500);
        }

        this.getFillList(countryActionId, "", "", "");
        this.getFillList(companyStatusActionId, "", "", "");
        if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
            console.log("log");
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }
        this.setState({
            OrderID:
                this.props.location.state != null &&
                    this.props.location.state.OrderID != null
                    ? this.props.location.state.OrderID
                    : "",
            OrderNo:
                this.props.location.state != null &&
                    this.props.location.state.OrderNo != null
                    ? this.props.location.state.OrderNo
                    : "",
            ClientID:
                this.props.location.state != null &&
                    this.props.location.state.ClientID != null
                    ? this.props.location.state.ClientID
                    : "",
            CompanyName:
                this.props.location.state != null &&
                    this.props.location.state.CompanyName != null
                    ? this.props.location.state.CompanyName
                    : "",
            PrimaryEmailID:
                this.props.location.state != null &&
                    this.props.location.state.PrimaryEmailID != null
                    ? this.props.location.state.PrimaryEmailID
                    : "",
            DeliveryStatus:
                this.props.location.state != null &&
                    this.props.location.state.DeliveryStatus != null
                    ? this.props.location.state.DeliveryStatus
                    : "",
            ProformaInvoiceID:
                this.props.location.state != null &&
                    this.props.location.state.ProformaInvoiceID != null
                    ? this.props.location.state.ProformaInvoiceID
                    : "",
            ProformaInvoice_No:
                this.props.location.state != null &&
                    this.props.location.state.ProformaInvoice_No != null
                    ? this.props.location.state.ProformaInvoice_No
                    : "",
            CenterID:
                this.props.location.state != null &&
                    this.props.location.state.CenterID != null
                    ? this.props.location.state.CenterID
                    : "",

            userId:
                sessionStorage.getItem("userId") == "" ||
                    sessionStorage.getItem("userId") == null
                    ? ""
                    : sessionStorage.getItem("userId"),
        });
        console.log("this.props.location.state", this.props.location.state);
        setTimeout(() => {
            this.getOrderEditDetails();

        }, 200);
        const ClientID = this.props.location.state?.ClientID || ""

        console.log("-----------------this.props", this.props)
    }

    sendNewPi() {
        const { OrderID, OrderNo, AdditionHours, securityEmailData, PrimaryEmailID, companyName, ProformaInvoiceID, ProformaInvoice_No } = this.state;
        this.props
            .send_new_pi_action(OrderID, OrderNo, companyName, PrimaryEmailID, ProformaInvoiceID, ProformaInvoice_No, securityEmailData, AdditionHours)
            .then((data) => {
                if (data.error !== 1) {
                    toastSuccess("exit submitted successfully!")
                    this.setState({ piSendShow: false, isLoading: false })
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/login')
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        toastError(data.msg);
                        this.setState({ isLoading: false, exitSub: false });
                    }
                }
            })
            .catch((err) => {
                console.error(err); // Logging the error for debugging
                this.setState({ isLoading: false, exitSub: false });
            });
    }

    clientSubmitExit() {
        const { OrderID, ExitSignatureData, exitIncludedServicesList, exitInhouseServicesList, exitInstructionList, unlistedAddServices, OrderNo, AdditionHours, exitVendorList,
            electricityExit, electricityPossesion, PossessionContactNameAndNumber, ExitContactNameAndNumber, exitConsumableList, exitMaterialList, exitSecurityList,
            exitMaterialNameAndServiceName, ExitSecurityChecklistNote, oppExitSignatureData, ExitOperationNameContact, securityEmailData, PrimaryEmailID, totalHrsEvent,
            additionalHrsCalculationAmount, sumOfAddtionalQauntityAmount, companyName, isExitClientSubmitted, exitAddChargesWaveOff, exitAddChargesWaveOffRemark, oldAsAmount } = this.state;
        if (exitAddChargesWaveOff == true && exitAddChargesWaveOffRemark == '') {
            toastError('Kindly Enter Remark for Additional Charges Wave off')
        } else {
            const possElectricity = electricityPossesion != '' && electricityPossesion != null ? electricityPossesion : 0
            const exitElectricity = electricityExit != '' && electricityExit != null ? electricityExit : 0

            var totalElectricityConsumed = ''
            if (exitElectricity > possElectricity) {
                if ((exitElectricity - possElectricity) > totalHrsEvent) {
                    totalElectricityConsumed = (exitElectricity - possElectricity) - totalHrsEvent
                } else {
                    totalElectricityConsumed = ''
                }
            } else {
                totalElectricityConsumed = ''
            }

            var totalElectricityAmount
            if (exitElectricity > totalHrsEvent) {
                totalElectricityAmount = (exitElectricity - electricityPossesion) - totalHrsEvent - AdditionHours
            } else {
                totalElectricityAmount = 0
            }
            const finalElectricityAmount = parseInt(totalElectricityAmount) * 480
            console.log(exitElectricity, electricityPossesion, totalHrsEvent, AdditionHours, finalElectricityAmount, additionalHrsCalculationAmount, "updateExitCheck")

            console.log("additionalHrsCalculationAmount--------", additionalHrsCalculationAmount)
            console.log("sumOfAddtionalQauntityAmount--------", sumOfAddtionalQauntityAmount)
            // console.log("AsAmount--------", oldAsAmount)
            var AsAmount
            if (exitAddChargesWaveOff == true) {
                AsAmount = oldAsAmount
            } else {
                console.log("AsAmount true", additionalHrsCalculationAmount, finalElectricityAmount, AdditionHours, finalElectricityAmount)
                if (AdditionHours != '' && AdditionHours != null && AdditionHours != 0) {
                    AsAmount = additionalHrsCalculationAmount + finalElectricityAmount
                } else {
                    AsAmount = oldAsAmount + sumOfAddtionalQauntityAmount + finalElectricityAmount
                }
            }
            console.log("OrderID--------", OrderID)
            console.log("AsAmount--------", AsAmount)

            const checkedConditionExitVendorList = exitVendorList.every((item) => item.IsClearanceGiven == 1 && item.ContactDetails != '' && item.ContactDetails != null)

            const newExitIncludedServiceList = []
            exitIncludedServicesList != '' ?
                exitIncludedServicesList.map((data) => {
                    if (data.IsSelected == 1) {
                        newExitIncludedServiceList.push(
                            {
                                "ServiceID": data.CenterServicesID,
                                "Quantity": data.Quantity != '' ? parseInt(data.Quantity) : 1,
                            }
                        )
                    }
                }) : <></>

            console.log("exitInhouseServicesList-------->", exitInhouseServicesList)

            const newExitInhouseServicesList = []
            exitInhouseServicesList != '' ?
                exitInhouseServicesList.map((data) => {
                    if (data.Is_checked == 1) {
                        newExitInhouseServicesList.push(
                            {
                                "ServiceID": data.CenterAdditionalServicesID,
                                "Quantity": data.Quantity != '' ? parseInt(data.Quantity) : null,
                                "AdditionalQuantity": data.AdditionalQuantity != '' ? parseInt(data.AdditionalQuantity) : null,
                                "Rate": data.Currency == 'INR' ? data.PriceInINR : data.PriceInUSD,
                                "AdditionalAmount": data.AdditionalAmount,
                            }
                        )
                    }
                }) : <></>

            const newExitInstructionList = []
            exitInstructionList != '' ?
                exitInstructionList.map((data) => {
                    if (data.IsSelected) {
                        newExitInstructionList.push(
                            {
                                "CheckListID": data.CheckListID != '' ? parseInt(data.CheckListID) : null,
                            }
                        )
                    }
                }) : <></>

            var intructionData = false
            const AllSelected = exitInstructionList.every(item => item.IsSelected == 1)
            if (AllSelected) {
                var intructionData = true
            } else {
                var intructionData = false
            }

            const consumableList = []
            exitConsumableList != '' ?
                exitConsumableList.map((data) => {
                    if (data.IsSelected) {
                        consumableList.push(
                            {
                                "ConsumableID": data.ConsumableID != '' ? parseInt(data.ConsumableID) : null,
                            }
                        )
                    }
                }) : <></>

            const MaterialList = []
            exitMaterialList != '' ?
                exitMaterialList.map((data) => {
                    if (data.IsSelected) {
                        MaterialList.push(
                            {
                                "VendorID": parseInt(data.VendorID),
                                "VendorServicesMaterialID": parseInt(data.VendorServicesMaterialID),
                                "ServiceID": parseInt(data.ServiceID),
                                "Quantity": parseInt(data.PossessionQuantity),
                            }
                        )
                    }
                }) : <></>

            const SecurityList = []
            exitSecurityList != '' ?
                exitSecurityList.map((data) => {
                    if (data.IsSelected) {
                        SecurityList.push(
                            {
                                "CenterSecurityChecklistID": parseInt(data.CenterSecurityChecklistID),
                            }
                        )
                    }
                }) : <></>

            const vendorPackageNoteList = []
            exitMaterialNameAndServiceName != '' ?
                exitMaterialNameAndServiceName.map((data) => {
                    vendorPackageNoteList.push(
                        {
                            "VendorID": parseInt(data.VendorID),
                            "ServiceID": parseInt(data.ServiceID),
                            "Note": data.Note,
                        }
                    )
                }) : <></>


            // Assuming that this.props.order_edit_details returns a Promise
            setTimeout(() => {
                const confirmed = window.confirm(
                    "Do you really want to submit Exit?"
                );
                if (confirmed) {
                    this.setState({ isLoading: true })
                    if (electricityPossesion != '' && electricityPossesion != 0 ? electricityExit >= electricityPossesion : true) {
                        if (checkedConditionExitVendorList) {
                            if (intructionData) {
                                if (ExitContactNameAndNumber != '' && ExitContactNameAndNumber != null) {
                                    if (ExitSignatureData != "") {

                                        this.props
                                            .insert_exist_list_action(OrderID, newExitIncludedServiceList, newExitInhouseServicesList, newExitInstructionList, ExitSignatureData, unlistedAddServices, OrderNo, AdditionHours, electricityExit, exitVendorList, ExitContactNameAndNumber, consumableList, MaterialList, SecurityList, ExitSecurityChecklistNote, vendorPackageNoteList, 0, oppExitSignatureData, ExitOperationNameContact, securityEmailData, 'client', PrimaryEmailID, AsAmount, companyName, true, exitAddChargesWaveOff, exitAddChargesWaveOffRemark, totalElectricityConsumed)
                                            .then((data) => {
                                                if (data.error !== 1) {
                                                    this.setState({
                                                        isLoading: false,
                                                        existDataListFlag: false,
                                                        isExitClientSubmitted: true
                                                    });
                                                    if (data.data != '') {

                                                        const url = BASE_URL.split("/api")[0];
                                                        const structurePath = data.data.filePath.replace('./', '/');
                                                        const exitPiFilePath = `${url}${structurePath}`;
                                                        this.setState({
                                                            piSendShow: true, ProformaInvoiceID: data.data[0].ProformaInvoiceID, ProformaInvoice_No: data.data[0].ProformaInvoice_No,
                                                            OrderID: data.data[0].OrderID, exitPiFilePath: exitPiFilePath, OrderNo: OrderNo
                                                        }, () => {

                                                            this.openSendPiModal(
                                                                data.data[0].ProformaInvoiceID,
                                                                data.data[0].ProformaInvoice_No,
                                                                data.data[0].OrderID, exitPiFilePath, OrderNo
                                                            );
                                                        })
                                                    }
                                                    toastSuccess("Submitted Successfully")
                                                    // this.updateProformaPrice()
                                                } else {
                                                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                                        //after session expire.....................
                                                        sessionStorage.clear()
                                                        this.props.navigate('/login')
                                                        setTimeout(() => {
                                                            toast.error(data.msg, {
                                                                position: "top-center",
                                                                theme: "colored",
                                                                autoClose: 3000,
                                                                hideProgressBar: true,
                                                            });
                                                        }, 500);
                                                    } else {
                                                        toastError(data.msg);
                                                        this.setState({ isLoading: false, exitSub: false });
                                                    }
                                                }
                                            })
                                            .catch((err) => {
                                                console.error(err); // Logging the error for debugging
                                                this.setState({ isLoading: false, exitSub: false });
                                            });

                                    } else {
                                        toastError("Please save Client signature!");
                                        this.setState({ isLoading: false })
                                    }
                                } else {
                                    toastError("Please enter Client contact name and number")
                                    this.setState({ isLoading: false })
                                }
                            } else {
                                toastError("Please tick all Exit CheckList!");
                                this.setState({ isLoading: false })
                            }
                        } else {
                            toastError("Please fill all External Services!");
                            this.setState({ isLoading: false })
                        }
                    } else {
                        toastError("Exit electricity unit must be greater than equal to Possession electricity unit!");
                        this.setState({ isLoading: false })
                    }
                }
            }, 500);
        }
    }

    openSendPiModal(ProformaInvoiceID, ProformaInvoice_No, OrderID, filePath, OrderNo) {
        // const url = BASE_URL.split("/api")[0];
        // const structurePath = filePath.toString().replace('./', '/');
        // const exitPiFilePath = `${url}${structurePath}`;
        this.setState({
            piSendShow: true, ProformaInvoiceID: ProformaInvoiceID, ProformaInvoice_No: ProformaInvoice_No, OrderID: OrderID, exitPiFilePath: filePath, OrderNo: OrderNo
        })
    }

    getFillList(value, userID, keyword, keyvalue) {
        // this.setState({ isLoading: true })
        this.props
            .fill_action(
                value,
                userID == "" || userID == null ? null : userID,
                keyword != "" ? keyword : null,
                keyvalue != "" ? keyvalue : null
            )
            .then((data) => {
                if (data.error != 1) {
                    if (value == countryActionId) {
                        this.setState({ countryList: data.data, isLoading: false });
                    }
                    if (value == companyStatusActionId) {
                        this.setState({ companyStatusList: data.data, isLoading: false });
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    submitPossessionList() {
        const { OrderID, possessionIncludedServicesList, possessionCheckList, possessionSignatureData, OrderNo, electricityPossesion, PossessionContactNameAndNumber, possessionConsumableList, SelectedExtService, possessionMaterialList, possessionSecurityList, possessionMaterialNameAndServiceName, PossessionSecurityChecklistNote, oppPossessionSignatureData, PosssesionOperationNameContact, PrimaryEmailID } = this.state;

        const newPossessionList = []
        possessionIncludedServicesList != '' ?
            possessionIncludedServicesList.map((data) => {
                if (data.IsSelected == 1) {
                    newPossessionList.push(
                        {
                            "ServiceID": data.CenterServicesID,
                            "Quantity": data.Quantity != '' ? parseInt(data.Quantity) : 1,
                        }
                    )
                }
            }) : <></>
        console.log("newPossessionList", newPossessionList)

        var intructionData = false
        const AllSelected = possessionCheckList.every(item => item.IsSelected == 1)
        if (AllSelected) {
            var intructionData = true
        } else {
            var intructionData = false
        }

        const newpossessionCheckList = []
        possessionCheckList != '' ?
            possessionCheckList.map((data) => {
                newpossessionCheckList.push(
                    {
                        "CheckListID": data.CheckListID != '' ? parseInt(data.CheckListID) : null,
                    }
                )
            }) : <></>

        const consumableList = []
        possessionConsumableList != '' ?
            possessionConsumableList.map((data) => {
                if (data.IsSelected) {
                    consumableList.push(
                        {
                            "ConsumableID": data.ConsumableID != '' ? parseInt(data.ConsumableID) : null,
                        }
                    )
                }
            }) : <></>

        const MaterialList = []
        possessionMaterialList != '' ?
            possessionMaterialList.map((data) => {
                if (data.IsSelected) {
                    MaterialList.push(
                        {
                            "VendorID": parseInt(data.VendorID),
                            "VendorServicesMaterialID": parseInt(data.VendorServicesMaterialID),
                            "ServiceID": parseInt(data.ServiceID),
                            "Quantity": parseInt(data.PossessionQuantity),
                        }
                    )
                }
            }) : <></>

        const SecurityList = []
        possessionSecurityList != '' ?
            possessionSecurityList.map((data) => {
                if (data.IsSelected) {
                    SecurityList.push(
                        {
                            "CenterSecurityChecklistID": parseInt(data.CenterSecurityChecklistID),
                        }
                    )
                }
            }) : <></>

        const vendorPackageNoteList = []
        possessionMaterialNameAndServiceName != '' ?
            possessionMaterialNameAndServiceName.map((data) => {
                vendorPackageNoteList.push(
                    {
                        "VendorID": parseInt(data.VendorID),
                        "ServiceID": parseInt(data.ServiceID),
                        "Note": data.Note,
                    }
                )
            }) : <></>

        // Assuming that this.props.order_edit_details returns a Promise
        const confirmed = window.confirm(
            "Do you really want to submit Possession?"
        );
        if (confirmed) {
            setTimeout(() => {
                this.setState({ isLoading: true })
                if (intructionData) {
                    if (PossessionContactNameAndNumber != '' && PossessionContactNameAndNumber != null) {
                        if (possessionSignatureData != "") {
                            if (PosssesionOperationNameContact != '' && PosssesionOperationNameContact != null) {
                                if (oppPossessionSignatureData != "") {
                                    this.setState({ possessionSub: true })
                                    this.props
                                        .insert_possession_list_action(OrderID, electricityPossesion, newPossessionList, newpossessionCheckList, possessionSignatureData, OrderNo, PossessionContactNameAndNumber, consumableList, MaterialList, SecurityList, PossessionSecurityChecklistNote, vendorPackageNoteList, oppPossessionSignatureData, PosssesionOperationNameContact, PrimaryEmailID)
                                        .then((data) => {
                                            if (data.error !== 1) {
                                                this.setState({ isLoading: false, });
                                                toastSuccess("Data added successfully!")
                                                // this.getOrderEditDetails()

                                                setTimeout(() => {
                                                    this.getExitList(SelectedExtService != '' ? SelectedExtService : null)
                                                    this.setState({
                                                        possessionDataListFlag: true,
                                                        possessionCheckListAllSelected: true,
                                                        PossesionSubmittedUser: data.data[0]['PossesionSubmittedUser'],
                                                        PossesionSubmittedDate: data.data[0]['PossessionSubmittedDate'],
                                                        isLoading: false
                                                    })
                                                    window.location.reload()
                                                }, 1000);
                                            } else {
                                                if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                                    //after session expire.....................
                                                    sessionStorage.clear()
                                                    this.props.navigate('/login')
                                                    setTimeout(() => {
                                                        toast.error(data.msg, {
                                                            position: "top-center",
                                                            theme: "colored",
                                                            autoClose: 3000,
                                                            hideProgressBar: true,
                                                        });
                                                    }, 500);
                                                } else {
                                                    toastError(data.msg);
                                                    this.setState({ isLoading: false, possessionSub: false });
                                                }
                                            }
                                        })
                                        .catch((err) => {
                                            console.error(err); // Logging the error for debugging
                                            this.setState({ isLoading: false, possessionSub: false });
                                        });
                                } else {
                                    toastError("Please save Operation signature!");
                                    this.setState({ isLoading: false })
                                }
                            } else {
                                toastError("Please enter Operation contact name and number")
                                this.setState({ isLoading: false })
                            }
                        } else {
                            toastError("Please save Client signature!");
                            this.setState({ isLoading: false })
                        }
                    } else {
                        toastError("Please enter Client contact name and number")
                        this.setState({ isLoading: false })
                    }
                } else {
                    toastError("Please tick all possession CheckList!");
                    this.setState({ isLoading: false })
                }
            }, 100);
        }
    }

    submitExitList(value, param) {
        const { OrderID, ExitSignatureData, exitIncludedServicesList, exitInhouseServicesList, exitInstructionList, unlistedAddServices, OrderNo, AdditionHours, exitVendorList, electricityExit, electricityPossesion, PossessionContactNameAndNumber, ExitContactNameAndNumber, exitConsumableList, exitMaterialList, exitSecurityList, exitMaterialNameAndServiceName, ExitSecurityChecklistNote, oppExitSignatureData, ExitOperationNameContact, securityEmailData, PrimaryEmailID, companyName, isExitClientSubmitted, exitAddChargesWaveOff, exitAddChargesWaveOffRemark } = this.state;
        var AsAmount = 0;
        const checkedConditionExitVendorList = exitVendorList.every((item) => item.IsClearanceGiven == 1 && item.ContactDetails != '' && item.ContactDetails != null)

        const newExitIncludedServiceList = []
        exitIncludedServicesList != '' ?
            exitIncludedServicesList.map((data) => {
                if (data.IsSelected == 1) {
                    newExitIncludedServiceList.push(
                        {
                            "ServiceID": data.CenterServicesID,
                            "Quantity": data.Quantity != '' ? parseInt(data.Quantity) : 1,
                        }
                    )
                }
            }) : <></>

        const newExitInhouseServicesList = []
        exitInhouseServicesList != '' ?
            exitInhouseServicesList.map((data) => {
                if (data.Is_checked == 1) {
                    newExitInhouseServicesList.push(
                        {
                            "ServiceID": data.CenterAdditionalServicesID,
                            "Quantity": data.Quantity != '' ? parseInt(data.Quantity) : null,
                            "AdditionalQuantity": data.AdditionalQuantity != '' ? parseInt(data.AdditionalQuantity) : null,
                            "Rate": data.Currency == 'INR' ? data.PriceInINR : data.PriceInUSD,
                            "AdditionalAmount": data.AdditionalAmount,
                        }
                    )
                }
            }) : <></>

        const newExitInstructionList = []
        exitInstructionList != '' ?
            exitInstructionList.map((data) => {
                if (data.IsSelected) {
                    newExitInstructionList.push(
                        {
                            "CheckListID": data.CheckListID != '' ? parseInt(data.CheckListID) : null,
                        }
                    )
                }
            }) : <></>

        var intructionData = false
        const AllSelected = exitInstructionList.every(item => item.IsSelected == 1)
        if (AllSelected) {
            var intructionData = true
        } else {
            var intructionData = false
        }

        const consumableList = []
        exitConsumableList != '' ?
            exitConsumableList.map((data) => {
                if (data.IsSelected) {
                    consumableList.push(
                        {
                            "ConsumableID": data.ConsumableID != '' ? parseInt(data.ConsumableID) : null,
                        }
                    )
                }
            }) : <></>

        const MaterialList = []
        exitMaterialList != '' ?
            exitMaterialList.map((data) => {
                if (data.IsSelected) {
                    MaterialList.push(
                        {
                            "VendorID": parseInt(data.VendorID),
                            "VendorServicesMaterialID": parseInt(data.VendorServicesMaterialID),
                            "ServiceID": parseInt(data.ServiceID),
                            "Quantity": parseInt(data.PossessionQuantity),
                        }
                    )
                }
            }) : <></>

        const SecurityList = []
        exitSecurityList != '' ?
            exitSecurityList.map((data) => {
                if (data.IsSelected) {
                    SecurityList.push(
                        {
                            "CenterSecurityChecklistID": parseInt(data.CenterSecurityChecklistID),
                        }
                    )
                }
            }) : <></>

        const vendorPackageNoteList = []
        exitMaterialNameAndServiceName != '' ?
            exitMaterialNameAndServiceName.map((data) => {
                vendorPackageNoteList.push(
                    {
                        "VendorID": parseInt(data.VendorID),
                        "ServiceID": parseInt(data.ServiceID),
                        "Note": data.Note,
                    }
                )
            }) : <></>


        // Assuming that this.props.order_edit_details returns a Promise
        setTimeout(() => {
            if (value) {
                const confirmed = window.confirm(
                    "Do you really want to final submit Exit?"
                );
                if (confirmed) {
                    this.setState({ isLoading: true })
                    if (electricityPossesion != '' && electricityPossesion != 0 ? electricityExit >= electricityPossesion : true) {
                        if (checkedConditionExitVendorList) {
                            if (intructionData) {
                                if (ExitContactNameAndNumber != '' && ExitContactNameAndNumber != null) {
                                    if (ExitSignatureData != "") {
                                        if (isExitClientSubmitted) {
                                            if (ExitOperationNameContact != '' && ExitOperationNameContact != null) {
                                                if (oppExitSignatureData != "") {

                                                    this.setState({
                                                        exitSub: true
                                                    })
                                                    this.props
                                                        .insert_exist_list_action(OrderID, newExitIncludedServiceList, newExitInhouseServicesList, newExitInstructionList, ExitSignatureData, unlistedAddServices, OrderNo, AdditionHours, electricityExit, exitVendorList, ExitContactNameAndNumber, consumableList, MaterialList, SecurityList, ExitSecurityChecklistNote, vendorPackageNoteList, value, oppExitSignatureData, ExitOperationNameContact, securityEmailData, param, PrimaryEmailID, AsAmount, companyName, isExitClientSubmitted, exitAddChargesWaveOff, exitAddChargesWaveOffRemark)
                                                        .then((data) => {
                                                            if (data.error !== 1) {
                                                                this.setState({
                                                                    isLoading: false,
                                                                    existDataListFlag: true,
                                                                    exitCheckListAllSelected: true,
                                                                    ExitSubmittedUser: data.data[0]['ExitSubmittedUser'],
                                                                    ExitSubmittedDate: data.data[0]['ExitSubmittedDate'],
                                                                });
                                                                toastSuccess("Data added successfully!")
                                                                // this.updateProformaPrice()
                                                            } else {
                                                                if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                                                    //after session expire.....................
                                                                    sessionStorage.clear()
                                                                    this.props.navigate('/login')
                                                                    setTimeout(() => {
                                                                        toast.error(data.msg, {
                                                                            position: "top-center",
                                                                            theme: "colored",
                                                                            autoClose: 3000,
                                                                            hideProgressBar: true,
                                                                        });
                                                                    }, 500);
                                                                } else {
                                                                    toastError(data.msg);
                                                                    this.setState({ isLoading: false, exitSub: false });
                                                                }
                                                            }
                                                        })
                                                        .catch((err) => {
                                                            console.error(err); // Logging the error for debugging
                                                            this.setState({ isLoading: false, exitSub: false });
                                                        });
                                                } else {
                                                    toastError("Please save Operations signature!");
                                                    this.setState({ isLoading: false })
                                                }
                                            } else {
                                                toastError("Please enter Operations contact name and number")
                                                this.setState({ isLoading: false })
                                            }
                                        } else {
                                            toastError("Please submit Client details!");
                                            this.setState({ isLoading: false })
                                        }
                                    } else {
                                        toastError("Please submit Client signature!");
                                        this.setState({ isLoading: false })
                                    }
                                } else {
                                    toastError("Please enter Client contact name and number")
                                    this.setState({ isLoading: false })
                                }
                            } else {
                                toastError("Please tick all Exit CheckList!");
                                this.setState({ isLoading: false })
                            }
                        } else {
                            toastError("Please fill all External Services!");
                            this.setState({ isLoading: false })
                        }
                    } else {
                        toastError("Exit electricity unit must be greater than equal to Possession electricity unit!");
                        this.setState({ isLoading: false })
                    }
                }
            } else {
                this.setState({ isLoading: true })
                this.props
                    .insert_exist_list_action(OrderID, newExitIncludedServiceList, newExitInhouseServicesList, newExitInstructionList, ExitSignatureData, unlistedAddServices, OrderNo, AdditionHours, electricityExit, exitVendorList, ExitContactNameAndNumber, consumableList, MaterialList, SecurityList, ExitSecurityChecklistNote, vendorPackageNoteList, value, oppExitSignatureData, ExitOperationNameContact, securityEmailData, param, PrimaryEmailID, AsAmount, companyName, isExitClientSubmitted, exitAddChargesWaveOff, exitAddChargesWaveOffRemark)
                    .then((data) => {
                        if (data.error !== 1) {
                            this.setState({
                                isLoading: false,
                                existDataListFlag: false,
                            });
                            toastSuccess("Data add in Draft!")
                        } else {
                            if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                //after session expire.....................
                                sessionStorage.clear()
                                this.props.navigate('/login')
                                setTimeout(() => {
                                    toast.error(data.msg, {
                                        position: "top-center",
                                        theme: "colored",
                                        autoClose: 3000,
                                        hideProgressBar: true,
                                    });
                                }, 500);
                            } else {
                                toastError(data.msg);
                                this.setState({ isLoading: false, exitSub: false });
                            }
                        }
                    })
                    .catch((err) => {
                        console.error(err); // Logging the error for debugging
                        this.setState({ isLoading: false, exitSub: false });
                    });
            }
        }, 500);
    }

    getpossesionList(VendorIdAndServiceIdList) {
        const { userId, OrderID, CenterID, existDataListFlag } = this.state;
        // this.setState({ isLoading: true });
        // Assuming that this.props.order_edit_details returns a Promise
        if (OrderID != null) {
            this.props
                .get_possession_list_action(CenterID, OrderID, VendorIdAndServiceIdList != '' ? VendorIdAndServiceIdList : null)
                .then((data) => {
                    if (data.error !== 1) {
                        this.setState({
                            // isLoading: false,
                            possessionIncludedServicesList: data.data["possesionIncludedServices"],
                            possessionCheckList: data.data["possessionCheckList"],
                            PossesionSubmittedUser: data.data['data'] != '' ? data.data['data'][0]['PossesionSubmittedUser'] : '',
                            PossesionSubmittedDate: data.data['data'] != '' ? data.data['data'][0]['PossessionSubmittedDate'] : '',
                            possessionTime: data.data['data'] != '' ? data.data['data'][0]['PossessionSubmittedDate'] : new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString(),
                            possessionVendorList: data.data['vendorList'],
                            electricityPossesion: data.data['data'] != '' ? data.data['data'][0]['PossessionElectricityUnit'] : '',
                            PossessionContactNameAndNumber: data.data['data'] != '' ? data.data['data'][0]['PossessionContactNameAndNumber'] : '',
                            PosssesionOperationNameContact: data.data['data'] != '' ? data.data['data'][0]['PosssesionOpeartionNameContact'] : '',
                            PossessionSecurityChecklistNote: data.data['data'] != '' ? data.data['data'][0]['PossessionSecurityChecklistNote'] : '',
                            possessionConsumableList: data.data['consumableList'],
                            possessionSecurityList: data.data['securityList'],
                        });
                        const allSelectConsumable = data.data['consumableList'].every(item => item.IsSelected == 1)
                        if (allSelectConsumable) {
                            this.setState({ possessionConsumableAllSelect: true })
                        } else {
                            this.setState({ possessionConsumableAllSelect: false })
                        }
                        if (data.data['materialList'] != "") {
                            data.data['materialList'].map((item) => {
                                item.isCollapsed = false
                            })
                            const arrayOfObjects = this.removeDuplicatesFromArray(data.data['materialList'])
                            // console.log("possessionMaterialList--", data.data['materialList'])
                            // console.log("arrayOfObjects--", arrayOfObjects)
                            this.setState({ possessionMaterialNameAndServiceName: arrayOfObjects, possessionMaterialList: data.data['materialList'] })
                        }
                        if (existDataListFlag) {
                            this.setState({ electricityExit: data.data['data'] != '' ? data.data['data'][0]['PossessionElectricityUnit'] : '', })
                        }
                        console.log(":data.data['vendorList']", data.data['vendorList'])
                        data.data["possessionInhouseServices"] != "" ? (
                            data.data["possessionInhouseServices"].map((item) => {
                                if (item.ServiceType == "S") {
                                    this.state.possessionInhouseServicesList.push(item);
                                }
                            })
                        ) : (
                            <></>
                        );

                        const includedChecked = data.data["possesionIncludedServices"].every(item => item.IsSelected == 1)
                        if (includedChecked) {
                            this.setState({ possServiceCheckAll: true })
                        } else {
                            this.setState({ possServiceCheckAll: false })
                        }

                        if (data.data['possessionImg'] != [] && data.data['possessionImg'] != '') {
                            const dataURL = 'data:image/png;base64,' + data.data['possessionImg']
                            this.setState({ possessionSignatureData: dataURL });
                            this.setState({ possessionDataListFlag: true, possessionCheckListAllSelected: true })
                        }
                        if (data.data['possessionOppImg'] != [] && data.data['possessionOppImg'] != '') {
                            const dataURL = 'data:image/png;base64,' + data.data['possessionOppImg']
                            this.setState({ oppPossessionSignatureData: dataURL, oppIsSignatureSaved: true });
                        }

                    } else {
                        if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                            //after session expire.....................
                            sessionStorage.clear()
                            this.props.navigate('/normalView')
                            setTimeout(() => {
                                toast.error(data.msg, {
                                    position: "top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                });
                            }, 500);
                        } else {
                            toastError(data.msg);
                            this.setState({ isLoading: false });
                        }
                    }
                })
                .catch((err) => {
                    console.error(err); // Logging the error for debugging
                    this.setState({ isLoading: false });
                });
        } else {
            this.props.navigate("/orders");
        }
    }
    getExitList(VendorIdAndServiceIdList) {
        const { userId, OrderID, CenterID } = this.state;
        // this.setState({ isLoading: true });
        // Assuming that this.props.order_edit_details returns a Promise
        if (OrderID != null) {
            this.props
                .get_exist_list_action(CenterID, OrderID, VendorIdAndServiceIdList != '' ? VendorIdAndServiceIdList : null)
                .then((data) => {
                    if (data.error !== 1) {

                        if (data.data['ExitSubmittedUser'] != undefined) {
                            this.setState({
                                ExitSubmittedUser: data.data['ExitSubmittedUser'],
                                ExitSubmittedDate: data.data['ExitSubmittedDate'],
                                exitTime: data.data['ExitSubmittedDate'],
                            })
                        }

                        this.setState({
                            isLoading: false,
                            exitInstructionList: data.data["ExitCheckList"],
                            exitVendorList: data.data["VendorList"],
                            unlistedAddServices: data.data['ExitRemark'],
                            electricityExit: data.data['data'] != '' ? data.data['data'][0]['ExitElectricityUnit'] : '',
                            ExitContactNameAndNumber: data.data['data'] != '' ? data.data['data'][0]['ExitContactNameAndNumber'] : '',
                            ExitOperationNameContact: data.data['data'] != '' ? data.data['data'][0]['ExitOperationNameContact'] : '',
                            ExitSecurityChecklistNote: data.data['data'] != '' ? data.data['data'][0]['ExitSecurityChecklistNote'] : '',
                            isExitClientSubmitted: data.data['data'] != '' ? data.data['data'][0]['isExitClientSubmitted'] : false,
                            exitAddChargesWaveOff: data.data['data'] != '' ? data.data['data'][0]['exitAddChargesWaveOff'] : false,
                            exitAddChargesWaveOffRemark: data.data['data'] != '' ? data.data['data'][0]['exitAddChargesWaveOffRemark'] : '',
                            exitConsumableList: data.data['consumableList'],
                            exitSecurityList: data.data['securityList'],
                        });
                        if (data.data['data'] != '') {
                            this.setState({
                                AdditionHours: data.data['data'][0]['ExitSubmittedDate'] != null ? data.data['data'][0]['AdditionHours'] : this.state.sortAdditionHours,
                            })
                        }
                        const allSelectConsumable = data.data['consumableList'].every(item => item.IsSelected == 1)
                        if (allSelectConsumable) {
                            this.setState({ exitConsumableAllSelect: true })
                        } else {
                            this.setState({ exitConsumableAllSelect: false })
                        }

                        setTimeout(() => {
                            var sumOfAdditionService = 0
                            var sumOfAddtionalQauntityAmount = 0
                            this.state.exitInhouseServicesList.map((item) => {
                                if (item.IsSelected) {
                                    sumOfAdditionService += item.Amount
                                    if (item.AdditionalQuantity != null && item.AdditionalQuantity != '') {
                                        if (item.Currency == 'INR') {
                                            sumOfAddtionalQauntityAmount += item.AdditionalQuantity * item.PriceInINR
                                        } else {
                                            sumOfAddtionalQauntityAmount += item.AdditionalQuantity * item.PriceInUSD
                                        }
                                    }
                                }
                            })
                            console.log(sumOfAdditionService, sumOfAddtionalQauntityAmount, "updateExitCheck 1")

                            const sumofServicesAmount = parseInt(sumOfAdditionService + sumOfAddtionalQauntityAmount)

                            this.setState({ sumOfAddtionalQauntityAmount: sumOfAddtionalQauntityAmount, oldAsAmount: sumOfAdditionService })
                            console.log("this.state.exitInhouseServicesList", this.state.exitInhouseServicesList)
                            if (data.data['data'] != '') {
                                if (data.data['data'][0]['ExitSubmittedDate'] != null) {
                                    const amount = this.additionalHrsCalculation(sumofServicesAmount, 0, data.data['data'][0]['AdditionHours'])
                                    console.log("amount--1", amount)
                                    this.setState({ additionalHrsCalculationAmount: amount });
                                } else {
                                    const amount = this.additionalHrsCalculation(sumofServicesAmount, 0, this.state.sortAdditionHours)
                                    console.log("amount--2", amount)
                                    this.setState({ additionalHrsCalculationAmount: amount });
                                }
                            }
                        }, 200);
                        if (data.data['materialList'] != "") {
                            data.data['materialList'].map((item) => {
                                item.isCollapsed = false
                            })
                            const arrayOfObjects = this.removeDuplicatesFromArray(data.data['materialList'])
                            console.log("arrayOfObjects", arrayOfObjects)
                            this.setState({ exitMaterialNameAndServiceName: arrayOfObjects, exitMaterialList: data.data['materialList'] })
                        }

                        // data.data["ExitIncludedServices"] != "" ? (
                        //     data.data["ExitIncludedServices"].map((item) => {

                        //         if (item.IsSelected == 1) {
                        //             item.Is_checked = 1
                        //         } else {
                        //             item.Is_checked = 0
                        //         }
                        //     })
                        // ) : (
                        //     <></>
                        // );

                        this.setState({ exitIncludedServicesList: data.data["ExitIncludedServices"] })


                        const list = []
                        data.data["ExitInhouseServices"] != "" ? (
                            data.data["ExitInhouseServices"].map((item) => {
                                if (item.ServiceType == "S") {
                                    if (item.IsSelected == 1) {
                                        item.Is_checked = 1
                                    } else {
                                        item.Is_checked = 0
                                    }
                                    list.push(item);
                                }
                            })
                        ) : (
                            <></>
                        );
                        this.setState({ exitInhouseServicesList: list })

                        if (data.data['ExitFilePath'] != '' && data.data['ExitFilePath'] != []) {
                            const dataURL = 'data:image/png;base64,' + data.data['ExitFilePath']
                            this.setState({ ExitSignatureData: dataURL, isSignatureSaved2: true });
                            if (data.data['data'][0]['FinalExitSubmit']) {
                                this.setState({
                                    exitCheckListAllSelected: true,
                                    existDataListFlag: data.data['ExitFilePath'] != '' ? true : false,
                                })
                            } else {
                                const checked = data.data["ExitCheckList"].every(item => item.IsSelected == 1)
                                if (checked) {
                                    this.setState({ exitCheckListAllSelected: true })
                                } else {
                                    this.setState({ exitCheckListAllSelected: false })
                                }
                            }
                        }

                        const includedChecked = data.data["ExitIncludedServices"].every(item => item.IsSelected == 1)
                        if (includedChecked) {
                            this.setState({ exitServiceCheckAll: true })
                        } else {
                            this.setState({ exitServiceCheckAll: false })
                        }

                        const checked = data.data["ExitCheckList"].every(item => item.IsSelected == 1)
                        if (checked) {
                            this.setState({ exitCheckListAllSelected: true })
                        } else {
                            this.setState({ exitCheckListAllSelected: false })
                        }

                        if (data.data['oppExitFilePath'] != '' && data.data['oppExitFilePath'] != []) {
                            const dataURL = 'data:image/png;base64,' + data.data['oppExitFilePath']
                            this.setState({ oppExitSignatureData: dataURL, oppIsSignatureSaved2: true });
                        }

                    } else {
                        if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                            //after session expire.....................
                            sessionStorage.clear()
                            this.props.navigate('/login')
                            setTimeout(() => {
                                toast.error(data.msg, {
                                    position: "top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                });
                            }, 500);
                        } else {
                            toastError(data.msg);
                            this.setState({ isLoading: false });
                        }
                    }
                })
                .catch((err) => {
                    console.error(err); // Logging the error for debugging
                    this.setState({ isLoading: false });
                });
        } else {
            this.props.navigate("/orders");
        }
    }

    removeDuplicatesFromArray(arrayOfObjects) {
        let uniqueMap = {};
        let uniqueArray = arrayOfObjects.filter(obj => {
            let key = obj.VendorID + '-' + obj.index;
            if (!uniqueMap[key]) {
                uniqueMap[key] = true;
                return true;
            }
            return false;
        });

        return uniqueArray;
    }
    getOrderEditDetails() {
        const { userId, OrderID, OrderNo, CompanyName, PrimaryEmailID } =
            this.state;
        this.setState({ isLoading: true });
        // Assuming that this.props.order_edit_details returns a Promise
        if (OrderID != null) {
            this.props
                .order_edit_details(userId, OrderID)
                .then((data) => {
                    if (data.error !== 1) {
                        setTimeout(() => {
                            if (data.data != '') {
                                this.createOrderConfirmationList(
                                    data.data,
                                    OrderNo,
                                    CompanyName,
                                    PrimaryEmailID
                                );
                                this.setState({
                                    // isLoading: false,
                                    noDueCertificate: data.data[1] != '' ? data.data[1][0]['Is_NoDue'] : '',
                                    exitPass: data.data[1] != '' ? data.data[1][0]['Is_ExitPass'] : '',
                                    isSecurityReceipt: data.data[1] != '' ? data.data[1][0]['isSecurityReceipt'] : '',
                                });
                            }
                        }, 300);
                        // this.setState({ isLoading: false })
                    } else {
                        if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                            //after session expire.....................
                            sessionStorage.clear()
                            this.props.navigate('/login')
                            setTimeout(() => {
                                toast.error(data.msg, {
                                    position: "top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                });
                            }, 500);
                        } else {
                            toastError(data.msg);
                            this.setState({ isLoading: false });
                        }
                    }
                })
                .catch((err) => {
                    console.error(err); // Logging the error for debugging
                    this.setState({ isLoading: false });
                });
        } else {
            this.props.navigate("/orders");
        }
    }

    formatOrderDate(orDate) {
        const options = { day: "numeric", month: "long", year: "numeric" };
        const date = new Date(orDate);
        return date.toLocaleDateString(undefined, options);
    }
    createOrderConfirmationList(data) {
        const { MyOrdersData } = this.state;
        const orderIDList = [];
        const finalList = [];
        const proformaList = [];

        for (const order of data[1]) {
            const orderID = order.OrderID;
            if (!orderIDList.includes(orderID)) {
                orderIDList.push(orderID);

                const summaryArr = data[0].filter(
                    (booking) => booking.OrderID === orderID
                );
                const additionalServicesArr = [];
                const data2 = data[2].filter((service) => service.OrderID === orderID);
                data2.map((item) => {
                    if (item.GrossAmount !== null) {
                        if (item.Type === "S") {
                            additionalServicesArr.push(item);
                        } else if (item.Type === "P") {
                            additionalServicesArr.push(item);
                        }
                    }
                });

                const objectID = {
                    OrderID: orderID,
                    summary: summaryArr,
                    additionalServices: additionalServicesArr,
                    centerName: order.CenterName,
                    centerAdd: order.ADDRESS,
                    OrderNo: order.OrderNo,
                    DeliveryStatus: order.OrderStatus,
                    StatusID: order.StatusID,
                    paymentStatus: order.PaymentStatus,
                    Is_NoDue: order.Is_NoDue,
                    NoDueDate: order.NoDueDate,
                    NoDueBy: order.NoDueBy,
                    Is_ExitPass: order.Is_ExitPass,
                    IsExitPassDate: order.IsExitPassDate,
                    AdditionalDiscount: order.AdditionalDiscount,
                    AdditionalDiscountNote: order.AdditionalDiscountNote,
                    DiscountAmount: order.DiscountAmount,
                    DiscountAmountNote: order.DiscountAmountNote,
                    EventServiceAmount: order.EventServiceAmount,
                    EventServiceNote: order.EventServiceNote,
                    SecurityDeposit: order.SecurityDeposit,
                    SecurityDepositRemark: order.SecurityDepositRemark,
                    ExitPassBy: order.ExitPassBy,
                    Is_Closure: order.Is_Closure,
                    currency: order.Currency,
                    RoleID: order.RoleID,
                    CenterID: order.CenterID,
                    ClientID: order.ClientID,
                    orderDate: this.formatOrderDate(order.OrderDate),
                    UUID: order.UUID,
                    IsMemberShip: order.IsMemberShip,
                    piFilePath: order.piFilePath,
                    exitPiFilePath: order.exitPiFilePath,
                    taxInvoiceFilePath: order.taxInvoiceFilePath,
                };

                const priceData = data[3].find((price) => price.OrderID === orderID);
                const proformaData = data[4].filter(
                    (proformaDetails) => proformaDetails.OrderID === orderID
                );
                const cancellationData = data[5].filter(
                    (cancel) => cancel.OrderID === orderID
                );
                const rejectionData = data[6].filter(
                    (rejected) => rejected.OrderID === orderID
                );
                const additionalChargesData = data[7].filter(
                    (addhourGet) => addhourGet.OrderID === orderID
                );
                const additionalChargesDetails = data[8].find(
                    (addhourDetails) => addhourDetails.OrderID === orderID
                );
                objectID.Price = priceData;
                objectID.proformaDetails = proformaData;
                objectID.cancelArr = cancellationData;
                objectID.RejectionData = rejectionData;
                objectID.additionalChargesData = additionalChargesData;
                objectID.additionalChargesDetails = additionalChargesDetails;

                finalList.push(objectID);
                proformaList.push(proformaData);

            }
        }

        this.setState({
            BookingDate: data[0][0].BookingDate,
            MyOrdersData: finalList,
            proformaList: proformaList,
            CenterID: finalList.map((data) => data.CenterID),
            ClientID: finalList.map((data) => data.ClientID),
            summaryArrList: data[0],
            piFilePath: finalList.map((data) => data.piFilePath),
            exitPiFilePath: finalList.map((data) => data.exitPiFilePath),
            taxInvoiceFilePath: finalList.map((data) => data.taxInvoiceFilePath),
        });
        if (
            (finalList.map((data) => data.CenterID) != null &&
                finalList.map((data) => data.ClientID) != null) ||
            (this.props.location.state.ClientID != null &&
                this.props.location.state.CenterID != null)
        ) {
            this.setState({
                CenterID: finalList.map((data) => data.CenterID).join(", "),
                ClientID: finalList.map((data) => data.ClientID).join(", "),
                DeliveryStatus: finalList.map((data) => data.DeliveryStatus),
            });

            this.props
                .client_detail_action(
                    finalList.map((data) => data.ClientID).join(", ") ||
                    this.props.location.state.ClientID
                )
                .then((data) => {
                    if (data.error != 1) {
                        // this.setState({ isLoading: true });
                        if (data.data != '') {
                            this.setState({
                                firstName: data.data[0]["FirstName"],
                                lastName: data.data[0]["LastName"],
                                designation: data.data[0]["Designation"],
                                companyStatusId: data.data[0]["CompanyStatusID"],
                                companyName: data.data[0]["CompanyName"],
                                addressLine1: data.data[0]["AddressLine1"],
                                addressLine2: data.data[0]["AddressLine2"],
                                cityId: data.data[0]["CityName"],
                                SAACityId: data.data[0]["Inv_CityName"],
                                stateId: data.data[0]["StateName"],
                                countryId: data.data[0]["CountryID"],
                                countryName: data.data[0]["CountryName"],
                                pincode: data.data[0]["Pincode"],
                                Mobile1: data.data[0]["Mobile1"],
                                Mobile2: data.data[0]["Mobile2"],
                                TelephoneNumber: data.data[0]["Telephone"],
                                primaryEmailID: data.data[0]["PrimaryEmailID"],
                                secondaryEmailID: data.data[0]["SecondaryEmailID"],
                                website: data.data[0]["Website"],
                                SameAsAbove: data.data[0]["IS_SameAsAbove"],
                                SAAFirstName: data.data[0]["Inv_FirstName"],
                                SAALastName: data.data[0]["Inv_LastName"],
                                SAADesignation: data.data[0]["Inv_Designation"],
                                SAACompanyName: data.data[0]["Inv_CompanyName"],
                                SAAAddressLine1: data.data[0]["Inv_AddressLine1"],
                                SAAAddressLine2: data.data[0]["Inv_AddressLine2"],
                                SAACityName: data.data[0]["Inv_CityName"],
                                SAAStateId: data.data[0]["Inv_StateName"],
                                SAACountryId: data.data[0]["Inv_CountryID"],
                                SAAPincode: data.data[0]["Inv_Pincode"],
                                SAAMobile1: data.data[0]["Inv_Mobile1"],
                                SAAMobile2: data.data[0]["Inv_Mobile2"],
                                SAATelephoneNumber: data.data[0]["Inv_Telephone"],
                                SAAPrimaryEmailID: data.data[0]["Inv_PrimaryEmailID"],
                                SAASecondaryEmailID: data.data[0]["Inv_SecondaryEmailID"],
                                SAAWebsite: data.data[0]["Inv_Website"],
                                registrationNumber: data.data[0]["CompanyRegistrationNo"],
                                PANCardNo: data.data[0]["PanNo"],
                                NameonPANCard: data.data[0]["NameOnPanCard"],
                                GSTNo: data.data[0]["GSTNo"],
                                TANNumber: data.data[0]["TanNo"],
                                UINNumber: data.data[0]["UINNo"],
                                ClientID: data.data[0]["ClientID"],
                                accountName: data.data[0]["AccountName"],
                                accountNo: data.data[0]["AccountNo"],
                                accountType: data.data[0]["AccountType"],
                                bankName: data.data[0]["BankName"],
                                branchName: data.data[0]["BranchName"],
                                IFSCCode: data.data[0]["IFSCCode"],
                                clientUser: data.data[0]["UserID"],
                                EventCordinatorName: data.data[0]["EventCordinatorName"],
                                EventCordinatorDesignation:
                                    data.data[0]["EventCordinatorDesignation"],
                                EventCordinatorEmail: data.data[0]["EventCordinatorEmail"],
                                EventCordinatorMobile: data.data[0]["EventCordinatorMobile"],
                                PrimaryContactName: data.data[0]["PrimaryContactName"],
                                PrimaryContactDesignation:
                                    data.data[0]["PrimaryContactDesignation"],
                                PrimaryContactEmail: data.data[0]["PrimaryContactEmail"],
                                PrimaryContactMobile: data.data[0]["PrimaryContactMobile"],
                            });
                            const { countryList, countryId } = this.state;

                            if (
                                data.data[0]["Telephone"] != null &&
                                data.data[0]["Telephone"].includes("-")
                            ) {
                                const concateData = data.data[0]["Telephone"].split("-");
                                this.setState({
                                    preTel: concateData[0],
                                    AreaCode: concateData[1],
                                    TelephoneNumber: concateData[2],
                                });
                            } else {
                                this.setState({ TelephoneNumber: data.data[0]["Telephone"] });
                            }

                            if (
                                data.data[0]["Inv_Telephone"] != null &&
                                data.data[0]["Inv_Telephone"].includes("-")
                            ) {
                                const concateData = data.data[0]["Inv_Telephone"].split("-");
                                this.setState({
                                    SAAPreTel: concateData[0],
                                    SAAAreaCode: concateData[1],
                                    SAATelephoneNumber: concateData[2],
                                });
                            } else {
                                this.setState({
                                    SAATelephoneNumber: data.data[0]["Inv_Telephone"],
                                });
                            }
                            setTimeout(() => {
                                countryList.map((itme) => {
                                    if (itme.Countryid == data.data[0]["CountryID"]) {
                                        this.setState({ ISD: itme.ExtensionCode });
                                    }
                                    if (itme.Countryid == data.data[0]["Inv_CountryID"]) {
                                        this.setState({ SAAISD: itme.ExtensionCode });
                                    }
                                });
                                this.getAdditionalServicesList();
                                this.getBookingDetails();

                            }, 500);
                        }
                        this.setState({ isLoading: false })
                    } else {
                        if (
                            data.msg == sessionExpireMessage ||
                            data.msg == tokenInavlidMessage
                        ) {
                            //after session expire.....................
                            sessionStorage.clear();
                            this.props.navigate("/normalView");
                            setTimeout(() => {
                                toast.error(data.msg, {
                                    position: "top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                });
                            }, 500);
                        } else {
                            this.setState({ isLoading: false });
                            toast.error(data.data, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
        const currencyArr = [...new Set(finalList.map((item) => item.currency))];
        const grandTotal = finalList.reduce(
            (total, item) => total + item.Price?.Total,
            0
        );
        this.setState({ grandTotal });

        if (currencyArr.length === 1) {
            this.setState({ finalCurrency: currencyArr[0] });
        }
    }
    formatDate(orDate) {
        if (typeof orDate !== "string" || !orDate.includes("/")) {
            return "--";
        }
        const date =
            typeof orDate === "string" ? this.parseDateFromString(orDate) : orDate;

        if (isNaN(date.getTime())) {
            return "--";
        }
        const options = { month: "long", day: "numeric", year: "numeric" };
        return date.toLocaleDateString(undefined, options);
    }
    parseDateFromString(dateString) {
        const parts = dateString.split("/");
        if (parts.length !== 3) {
            return new Date(NaN);
        }
        const formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
        return new Date(formattedDate);
    }
    //booking details
    getBookingDetails() {
        const { OrderID } = this.state;
        const id =
            this.props.location.state != null &&
                this.props.location.state.OrderID != null
                ? this.props.location.state.OrderID
                : "";
        this.props
            .get_booking_Details_action(id)
            .then((data) => {
                if (data.error != 1) {
                    const dateList = []
                    var totalHrsEvent = 0
                    data.data['tableData'].map((item, i) => {
                        totalHrsEvent += item.SelectedHr
                        if (i === 0) {
                            dateList.push(item.EventStartDate)
                        }
                        if (i + 1 === data.data['tableData'].length) {
                            dateList.push(item.EventEndDate)
                        }
                    })
                    this.setState({
                        totalHrsEvent: totalHrsEvent,
                        securityEmailData: {
                            eventDate: data.data['tableData'].length == 1 ? dateList[0] : dateList[0] + '-' + dateList[1],
                            eventName: data.data['data'][0]['TypeOfEvent']
                        },

                    })
                    // setTimeout(() => {
                    //     console.log("this.state.securityEmailData", this.state.securityEmailData)
                    // }, 200);

                    const BookingEventDataList = data.data["tableData"].map((item) => {
                        return {
                            EventStartDate: item.EventStartDate,
                            EventEndDate: item.EventEndDate,
                            EventStartTime: item.EventStartTime,
                            EventEndTime: item.EventEndTime,
                        };
                    });
                    console.log("sagar----->", data.data['tableData'])
                    setTimeout(() => {
                        const summaryArr = this.state.summaryArrList
                        const array1 = []
                        const array2 = []
                        const array3 = []
                        const array4 = []
                        for (let i = 0; i < summaryArr.length; i++) {
                            const result1 = summaryArr[i]['BookingSlot'].match(/\d{2}:\d{2}/)?.[0];
                            const result2 = summaryArr[i]['BookingSlot'].match(/(\d{2}:\d{2})/g)?.pop()
                            array1.push(result1)
                            array2.push(result2)
                            array3.push(BookingEventDataList[i]['EventStartTime'])
                            array4.push(BookingEventDataList[i]['EventEndTime'])
                        }
                        const totalHrs = this.countConsumableHours(array1, array3, 'startTime')
                        const totalHrs2 = this.countConsumableHours(array2, array4, 'endTime')
                        console.log("sortAdditionHours------->", totalHrs + totalHrs2)
                        if (!this.state.existDataListFlag) {
                            this.setState({ sortAdditionHours: totalHrs + totalHrs2 })
                        }
                    }, 100);
                    this.setState({
                        TypeOfEvent: data.data['data'][0]["TypeOfEvent"],
                        SittingArrangement: data.data['data'][0]["SittingType"],
                        bookingList: data.data['tableData'],
                        BookingEventDataList: BookingEventDataList,
                        // possesion
                        PossesionStartDate:
                            data.data['tableData'][0]["PossessionStartDate"] != "" &&
                                data.data['tableData'][0]["PossessionStartDate"] != null
                                ? moment(
                                    data.data['tableData'][0]["PossessionStartDate"],
                                    "YYYY-MM-DD"
                                ).toDate()
                                : "",
                        PossesionEndDate:
                            data.data['tableData'][0]["PossessionEndDate"] != "" &&
                                data.data['tableData'][0]["PossessionEndDate"] != null
                                ? moment(
                                    data.data['tableData'][0]["PossessionEndDate"],
                                    "YYYY-MM-DD"
                                ).toDate()
                                : "",
                        PossesionStartTime:
                            data.data['tableData'][0]["PossessionStartTime"] != "" &&
                                data.data['tableData'][0]["PossessionStartTime"] != null
                                ? data.data['tableData'][0]["PossessionStartTime"]
                                : "",
                        PossesionEndTime:
                            data.data['tableData'][0]["PossessionEndTime"] != "" &&
                                data.data['tableData'][0]["PossessionEndTime"] != null
                                ? data.data['tableData'][0]["PossessionEndTime"]
                                : "",

                        // Dismantle
                        dismantleStartDate:
                            data.data['tableData'][0]["DismentalStartDate"] != "" &&
                                data.data['tableData'][0]["DismentalStartDate"] != null
                                ? moment(
                                    data.data['tableData'][0]["DismentalStartDate"],
                                    "YYYY-MM-DD"
                                ).toDate()
                                : "",
                        dismantleEndDate:
                            data.data['tableData'][0]["DismentalEndDate"] != "" &&
                                data.data['tableData'][0]["DismentalEndDate"] != null
                                ? moment(
                                    data.data['tableData'][0]["DismentalEndDate"],
                                    "YYYY-MM-DD"
                                ).toDate()
                                : "",
                        dismantleStartTime:
                            data.data['tableData'][0]["DismentalStartTime"] != "" &&
                                data.data['tableData'][0]["DismentalStartTime"] != null
                                ? data.data['tableData'][0]["DismentalStartTime"]
                                : "",
                        dismantleEndTime:
                            data.data['tableData'][0]["DismentalEndTime"] != "" &&
                                data.data['tableData'][0]["DismentalEndTime"] != null
                                ? data.data['tableData'][0]["DismentalEndTime"]
                                : "",
                    });

                    if (
                        data.data['data'][0]["SittingTypeID"] != "" &&
                        data.data['data'][0]["SittingTypeID"] != null
                    ) {
                        this.setState({ NoOfPAXFlag: false });
                    } else {
                        this.setState({ NoOfPAXFlag: true, NoofPAX: "" });
                    }

                    data.data['data'][0]["MembershipFilePath"] == null ? (
                        this.setState({
                            fileName: "",
                            formFile: "",
                            fileType: "",
                        })
                    ) : (
                        <></>
                    );

                    for (let i = 0; i < data.data['tableData'].length; i++) {
                        if (data.data['tableData'].length - 1 == i) {
                            this.setState({
                                LastDate: data.data['tableData'][i]["Date"],
                            });
                        }
                    }
                } else {
                    this.setState({ isLoading: false });
                    toast.error(data.data, {
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                    });
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    countConsumableHours(arrya1, arrya2, value) {
        // Validate arrays have the same length
        if (arrya1.length !== arrya2.length) {
            throw new Error("Arrays must have the same length");
        }

        let totalConsumableHrs = 0;

        // Iterate through each pair of times in the arrays
        for (let i = 0; i < arrya1.length; i++) {
            let time1 = arrya1[i];
            let time2 = arrya2[i];
            // Compare times as strings (lexicographical comparison)
            if (value == 'startTime') {
                if (time1 > time2) {
                    var data = this.calculateHourDifference(time1, time2)
                    totalConsumableHrs += data; // Increment by 2 as per your requirement
                }
            } else if (value == 'endTime') {
                if (time1 < time2) {
                    var data = this.calculateHourDifference(time1, time2)
                    totalConsumableHrs += data; // Increment by 2 as per your requirement
                }
            }
        }

        return totalConsumableHrs;
    }
    calculateHourDifference(time1, time2) {
        // Function to convert time string to minutes since midnight
        function convertTimeToMinutes(timeString) {
            let [hours, minutes] = timeString.split(':').map(Number);
            return hours * 60 + minutes;
        }

        // Convert time strings to minutes since midnight
        let minutes1 = convertTimeToMinutes(time1);
        let minutes2 = convertTimeToMinutes(time2);

        // Calculate difference in hours
        let hourDifference = Math.abs(minutes1 - minutes2) / 60;

        return hourDifference;
    }

    getAdditionalServicesList() {
        const { orderDtlID } = this.state;
        const CenterID =
            this.props.location.state != null &&
                this.props.location.state.CenterID != null
                ? this.props.location.state.CenterID
                : "";
        const OrderID =
            this.props.location.state != null &&
                this.props.location.state.OrderID != null
                ? this.props.location.state.OrderID
                : "";
        // this.setState({ isLoading: true })
        this.props
            .get_additional_services_action(OrderID, CenterID)
            .then((data) => {
                if (data.error != 1) {
                    // console.log("additionalServicesList1234", data.data['additionServices'])
                    if (data.data["externalServices"] != "") {
                        data.data["externalServices"].map((item) => {
                            if (item.Qty == 0) {
                                item.Qty = null;
                            }
                        });
                        this.setState({
                            externalServices: data.data["externalServices"],
                        });
                    }
                    if (data.data["additionServices"] != "") {
                        this.setState({
                            CurrencyID: data.data["additionServices"][0]["CurrencyID"],
                        });
                    }
                    if (data.data["otherData"] != "") {
                        this.setState({
                            unlistedAddServices:
                                data.data["otherData"][0]["UnlistedAddServices"],
                        });
                    }
                    if (data.data["includedServices"] != "") {
                        this.setState({ includedServices: data.data["includedServices"] });
                    }

                    for (let i = 0; i < data.data["additionServices"].length; i++) {
                        const filterData = data.data["additionServices"].filter(
                            (item) => item.Name == data.data["additionServices"][i]["Name"]
                        );

                        if (filterData.length == 2) {
                            data.data["additionServices"][i]["Disabled"] = 2;
                        } else {
                            data.data["additionServices"][i]["Disabled"] = 1;
                        }

                        if (filterData.length == 2) {
                            filterData.map((item) => {
                                if (item.IsSelected == 1) {
                                    item.Is_SelectedServiceId = 1;
                                }
                            });
                        }

                        let checked = filterData.every((obj) => obj.IsSelected == 0);
                        if (checked) {
                            data.data["additionServices"][i]["Is_SelectedServiceId"] = 1;
                        } else {
                            if (data.data["additionServices"][i]["ServiceType"] == "S") {
                                data.data["additionServices"][i]["Is_SelectedServiceId"] = 1;
                            }
                        }
                    }


                    this.setState({
                        additionalServicesList: data.data["additionServices"],
                    });
                    // this.setState({ isLoading: false });
                    //selected External
                    // Assuming data is an object containing your data

                    // Assuming filteredServices is the array containing filtered data
                    if (data.data["materialList"] != '') {
                        const selectedData = data.data["materialList"].map((item) => ({
                            ServiceID: item.ServiceID,
                            VendorID: item.VendorID,
                            VendorServicesMaterialID: item.VendorServicesMaterialID
                        }));
                        this.setState(
                            {
                                SelectedExtService: selectedData,
                            },
                            () => {
                                this.getpossesionList(selectedData);
                                setTimeout(() => {
                                    this.getExitList(selectedData);
                                }, 100);
                            }
                        );
                    } else {
                        const filteredServices = data.data["externalServices"].filter(
                            (item) => item.IsSelected === 1
                        );
                        const selectedData = filteredServices.map((item) => ({
                            ServiceID: item.ServiceID,
                            VendorID: item.VendorID,
                            VendorServicesMaterialID: null
                        }));
                        // Update the state with the filtered services
                        this.setState(
                            {
                                SelectedExtService: selectedData,
                            },
                            () => {
                                this.getpossesionList(selectedData);
                                setTimeout(() => {

                                    this.getExitList(selectedData);
                                }, 100);
                            }
                        );
                    }

                } else {
                    if (
                        data.msg == sessionExpireMessage ||
                        data.msg == tokenInavlidMessage
                    ) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/normalView");
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false });
                        toast.error(data.data, {
                            position: "top-center",
                            theme: "colored",
                            autoClose: 3000,
                            hideProgressBar: true,
                        });
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    additionalHrsCalculation(totalAmount, additionalquantityprice, additionalHour) {
        console.log(totalAmount, additionalquantityprice, additionalHour, "updateExitCheck 4")
        // const amount = ((((totalAmount + additionalquantityprice) / 8) * additionalHour) + totalAmount + additionalquantityprice)
        var amount
        if (additionalHour != 0 && additionalHour != '' && additionalHour != null) {
            if (additionalquantityprice != 0) {
                amount = (((totalAmount + additionalquantityprice) / 8) * parseInt(additionalHour)) + additionalquantityprice
            } else {
                amount = ((totalAmount) / 8) * parseInt(additionalHour)
            }
        } else if (additionalquantityprice != 0) {
            amount = additionalquantityprice
        } else {
            amount = 0
        }
        console.log(amount, "updateExitCheck 2")
        return amount
    }

    backToCheckList() {
        this.props.navigate("/checkList");
    }

    // possesion Client Signature
    signatureRef = React.createRef();
    clearSignature = () => {
        this.signatureRef.current.clear();
        this.setState({
            isSignatureSaved: false,
        });
    };
    clearSaveSignatureImg = () => {
        this.setState({
            possessionSignatureData: "",
            isSignatureSaved: false,
            isSignatureSaveFlag: false,
        });
    };
    saveSignature = () => {
        const possessionSignatureData = this.signatureRef.current.toDataURL();
        { console.log("this.signatureRef.current.isEmpty()", possessionSignatureData) }

        if (this.signatureRef.current.isEmpty() == false) {
            this.setState({
                possessionSignatureData: possessionSignatureData,
                isSignatureSaved: true,
                isSignatureSaveFlag: true,
            });
        } else {
            toastError("Please fill signature!");
        }
    };

    // possesion Operations Signature
    oppSignatureRef = React.createRef();
    clearOppSignature = () => {
        this.oppSignatureRef.current.clear();
        this.setState({
            oppIsSignatureSaved: false,
        });
    };
    clearOppSaveSignatureImg = () => {
        this.setState({
            oppPossessionSignatureData: "",
            oppIsSignatureSaved: false,
            oppIsSignatureSaveFlag: false,
        });
    };
    saveOppSignature = () => {
        const oppPossessionSignatureData = this.oppSignatureRef.current.toDataURL();

        if (this.oppSignatureRef.current.isEmpty() == false) {
            this.setState({
                oppPossessionSignatureData: oppPossessionSignatureData,
                oppIsSignatureSaved: true,
                oppIsSignatureSaveFlag: true,
            });
        } else {
            toastError("Please fill Operation signature!");
        }
    };

    // possession included
    possessionIncludedCheckbox(index, IsSelected, e) {
        const { possessionIncludedServicesList, possessionDataListFlag } = this.state;
        const cList = [...possessionIncludedServicesList];
        const event = e.target.checked;

        cList.forEach((data, i) => {
            if (i === index) {
                if (IsSelected == 0) {
                    if (possessionDataListFlag == true) {
                        data.IsSelected = 0;
                    } else {
                        data.IsSelected = 1;
                        data.Quantity = 1;
                    }
                } else {
                    if (possessionDataListFlag == true) {
                        data.IsSelected = 1;
                    } else {
                        data.IsSelected = 0;
                        data.Quantity = "";
                    }
                }
            }
        });
        const allSelect = cList.every(item => item.IsSelected == 1)
        if (allSelect) {
            this.setState({ possServiceCheckAll: true })
        } else {
            this.setState({ possServiceCheckAll: false })
        }
        this.setState({
            possessionIncludedServicesList: cList,
        });
        // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
    }
    ispossessionIncludedQuantity(e, index, name) {
        const { possessionIncludedServicesList } = this.state;
        const cList = [...possessionIncludedServicesList];

        const event = e.target.value.replace(/\D/, "");

        cList.forEach((data, i) => {
            if (data.Name == name) {
                if (i === index) {
                    if (event > 0) {
                        data.Quantity = event;
                    } else {
                        data.Quantity = "";
                    }
                    this.setState({
                        possessionIncludedServicesList: cList,
                    });
                }
            }
        });

        this.setState({
            possessionIncludedServicesList: cList,
        });
    }

    onBlurIsExitIncludedQuantity(e, index, name) {
        const { exitIncludedServicesList } = this.state;
        const cList = [...exitIncludedServicesList];

        const event = e.target.value;

        cList.forEach((data, i) => {
            if (data.Name == name) {
                if (i === index) {
                    if (event == '') {
                        data.Quantity = 1;
                    }
                }
            }
        });

        this.setState({
            exitIncludedServicesList: cList,
        });
    }

    onBlurIspossessionIncludedQuantity(e, index, name) {
        const { possessionIncludedServicesList } = this.state;
        const cList = [...possessionIncludedServicesList];

        const event = e.target.value;

        cList.forEach((data, i) => {
            if (data.Name == name) {
                if (i === index) {
                    if (event == '') {
                        data.Quantity = 1;
                    }
                }
            }
        });

        this.setState({
            possessionIncludedServicesList: cList,
        });
    }
    // possession inhouse
    possessionInhouseCheckbox(index, IsSelected, e) {
        const { possessionInhouseServicesList } = this.state;
        const cList = [...possessionInhouseServicesList];
        const event = e.target.checked;

        cList.forEach((data, i) => {
            if (i === index) {
                if (IsSelected == 0) {
                    data.IsSelected = 0;
                } else {
                    data.IsSelected = 1;
                }
            }
        });

        this.setState({
            possessionInhouseServicesList: cList,
        });
    }
    ispossessionInhouseQuantity(e, index, name) {
        const { possessionInhouseServicesList } = this.state;
        const cList = [...possessionInhouseServicesList];

        const event = e.target.value.replace(/\D/, "");

        cList.forEach((data, i) => {
            if (data.Name == name) {
                if (i === index) {
                    if (event > 0) {
                        data.Quantity = event;
                        if (data.Currency == "INR") {
                            data.Amount = event * data.PriceInINR;
                        } else {
                            data.Amount = event * data.PriceInUSD;
                        }
                    } else {
                        data.Quantity = "";
                        if (data.Currency == "INR") {
                            data.Amount = null;
                        } else {
                            data.Amount = null;
                        }
                    }
                    this.setState({
                        possessionInhouseServicesList: cList,
                    });
                }
            }
        });

        this.setState({
            possessionInhouseServicesList: cList,
        });
    }


    possessionCheckList(index, IsSelected, e) {
        const { possessionCheckList, possessionDataListFlag } = this.state;
        const cList = [...possessionCheckList];
        const event = e.target.checked;

        cList.forEach((data, i) => {
            if (i === index) {
                if (!possessionDataListFlag) {
                    if (event) {
                        data.IsSelected = 1
                    } else {
                        data.IsSelected = 0
                    }
                }
            }
        });

        const allSelected = cList.every((data) => data.IsSelected == 1)

        if (allSelected) {
            this.setState({ possessionCheckListAllSelected: true })
        } else {
            this.setState({ possessionCheckListAllSelected: false })
        }

        this.setState({
            possessionCheckList: cList,
        });

    }

    // exit included
    existIncludedCheckbox(index, IsSelected, e) {
        const { exitIncludedServicesList, existDataListFlag } = this.state;
        const cList = [...exitIncludedServicesList];
        const event = e.target.checked;

        cList.forEach((data, i) => {
            if (i === index) {
                if (!existDataListFlag) {
                    if (event) {
                        data.Quantity = 1;
                        data.IsSelected = 1
                    } else {
                        data.IsSelected = 0
                        data.Quantity = ""
                    }
                }
            }
        });

        const allSelect = cList.every(item => item.Is_checked == 1)
        if (allSelect) {
            this.setState({ exitServiceCheckAll: true })
        } else {
            this.setState({ exitServiceCheckAll: false })
        }

        this.setState({
            exitIncludedServicesList: cList,
        });
    }

    exitIncludedQuantity(e, index, name) {
        const { exitIncludedServicesList, existDataListFlag } = this.state;
        const cList = [...exitIncludedServicesList];

        const event = e.target.value.replace(/\D/, "");

        cList.forEach((data, i) => {
            if (data.Name == name) {
                if (i === index) {
                    if (event > 0) {
                        data.Quantity = event;
                    } else {
                        data.Quantity = "";
                    }
                    this.setState({
                        exitIncludedServicesList: cList,
                    });
                }
            }
        });

        this.setState({
            exitIncludedServicesList: cList,
        });
    }

    ExitInhouseCheckbox(index, IsSelected, e, name) {
        const { exitInhouseServicesList, existDataListFlag } = this.state;
        const cList = [...exitInhouseServicesList];
        const event = e.target.checked;
        const electricityFlag = name.split(' ').includes('Electricity')
        cList.forEach((data, i) => {
            if (i === index) {
                if (!existDataListFlag) {
                    if (data.Quantity != null) {
                        if (IsSelected == 0) {
                            data.Is_checked = 0;
                        } else {
                            data.Is_checked = 1;
                        }
                    } else {
                        if (event) {
                            data.Is_checked = 1;
                            data.IsSelected = 1;
                            data.AdditionalQuantity = 1;
                            if (data.Currency == 'INR') {
                                if (electricityFlag) {
                                    data.Amount = (data.PriceInINR) * 30
                                    data.AdditionalAmount = (data.PriceInINR) * 30
                                } else {
                                    data.Amount = (data.PriceInINR)
                                    data.AdditionalAmount = (data.PriceInINR)
                                }
                            } else {
                                if (electricityFlag) {
                                    data.Amount = (data.PriceInUSD) * 30
                                    data.AdditionalAmount = (data.PriceInUSD) * 30
                                } else {
                                    data.Amount = (data.PriceInUSD)
                                    data.AdditionalAmount = (data.PriceInUSD)
                                }
                            }
                        } else {
                            data.Is_checked = 0;
                            data.IsSelected = 0;
                            data.AdditionalQuantity = '';
                            data.AdditionalAmount = 0
                            data.Amount = 0
                        }
                    }
                }
            }
        });
        setTimeout(() => {
            var sumOfAddtionalAmount = 0
            var sumOfAddtionalQauntityAmount = 0
            cList.map(item => {
                if (item.IsSelected) {
                    console.log(item.Name, "--------->", item.Amount)
                    sumOfAddtionalAmount += item.Amount
                    sumOfAddtionalQauntityAmount += item.AdditionalAmount != undefined ? item.AdditionalAmount : 0
                }
            })
            const amount = this.additionalHrsCalculation(sumOfAddtionalAmount, sumOfAddtionalQauntityAmount, this.state.AdditionHours)
            this.setState({
                additionalHrsCalculationAmount: amount,
                sumOfAddtionalQauntityAmount: sumOfAddtionalQauntityAmount,
            });

        }, 100);

        this.setState({
            exitInhouseServicesList: cList,
        });
    }

    exitInhouseAdditionQuantity(e, index, name) {
        const { exitInhouseServicesList, existDataListFlag } = this.state;
        const cList = [...exitInhouseServicesList];
        const electricityFlag = name.split(' ').includes('Electricity')
        const event = e.target.value.replace(/\D/, "");
        cList.forEach((data, i) => {
            if (data.Name == name) {
                if (i === index) {
                    if (event > 0) {
                        data.AdditionalQuantity = event;
                        if (data.CurrencyID != 1) {
                            // data.Amount = event * data.PriceInINR;
                            if (electricityFlag) {
                                data.AdditionalAmount = (data.PriceInINR) * 30 * event
                            } else {
                                data.AdditionalAmount = (data.PriceInINR) * event
                            }
                        } else {
                            // data.Amount = event * data.PriceInUSD
                            if (electricityFlag) {
                                data.AdditionalAmount = (data.PriceInUSD) * 30 * event
                            } else {
                                data.AdditionalAmount = (data.PriceInUSD) * event
                            }
                        }
                    } else {
                        data.AdditionalQuantity = "";
                        if (data.Quantity == null) {
                            if (data.CurrencyID != 1) {
                                if (electricityFlag) {
                                    data.AdditionalAmount = (data.PriceInINR) * 30 * 1
                                } else {
                                    data.AdditionalAmount = (data.PriceInINR)
                                }
                            } else {
                                if (electricityFlag) {
                                    data.AdditionalAmount = (data.PriceInUSD) * 30 * 1
                                } else {
                                    data.AdditionalAmount = (data.PriceInUSD)
                                }
                            }
                        } else {
                            data.AdditionalAmount = 0
                        }
                    }
                    this.setState({
                        exitInhouseServicesList: cList,
                    });
                }
            }
        });

        var sumOfAddtionalAmount = 0
        var sumOfAddtionalQauntityAmount = 0
        cList.map(item => {
            if (item.IsSelected) {
                sumOfAddtionalAmount += item.Amount
                sumOfAddtionalQauntityAmount += item.AdditionalAmount != undefined ? item.AdditionalAmount : 0
            }
        })
        const amount = this.additionalHrsCalculation(sumOfAddtionalAmount, sumOfAddtionalQauntityAmount, this.state.AdditionHours)
        console.log("sumOfAddtionalAmount", sumOfAddtionalAmount)
        console.log("sumOfAddtionalQauntityAmount", sumOfAddtionalQauntityAmount)
        console.log("amount", amount)

        this.setState({
            additionalHrsCalculationAmount: amount,
            exitInhouseServicesList: cList,
            sumOfAddtionalQauntityAmount: sumOfAddtionalQauntityAmount
        });
    }

    onBlurExitInhouseAdditionQuantity(e, index, name) {
        const { exitInhouseServicesList, existDataListFlag } = this.state;
        const cList = [...exitInhouseServicesList];

        const event = e.target.value.replace(/\D/, "");

        cList.forEach((data, i) => {
            if (data.Name == name) {
                if (i === index) {
                    if (data.Quantity == null) {
                        if (event == '') {
                            data.AdditionalQuantity = 1;
                        }
                    }
                }
            }
        });

        this.setState({
            exitInhouseServicesList: cList,
        });
    }

    // exit inntruction
    exitInstructionCheckbox(index, IsSelected, e) {
        const { exitInstructionList, existDataListFlag } = this.state;
        const cList = [...exitInstructionList];
        const event = e.target.checked;
        console.log("event", event);

        cList.forEach((data, i) => {
            if (i === index) {
                if (!existDataListFlag) {
                    if (IsSelected == 0) {
                        data.IsSelected = 1;
                    } else {
                        data.IsSelected = 0;
                    }
                }
            }
        });

        const allSelected = cList.every((data) => data.IsSelected == 1)

        if (allSelected) {
            this.setState({ exitCheckListAllSelected: true })
        } else {
            this.setState({ exitCheckListAllSelected: false })
        }

        this.setState({
            exitInstructionList: cList,
        });
    }

    // exit CLient Signature
    signatureRef2 = React.createRef();
    clearSignature2 = () => {
        this.signatureRef2.current.clear();
        this.setState({
            isSignatureSaved2: false,
        });
    };
    clearSaveSignatureImg2 = () => {
        this.setState({
            ExitSignatureData: "",
            isSignatureSaved2: false,
            isSignatureSaveFlag2: false,
        });
    };
    saveSignature2 = () => {
        const exitSignatureData = this.signatureRef2.current.toDataURL();
        if (this.signatureRef2.current.isEmpty() == false) {
            this.setState({
                ExitSignatureData: exitSignatureData,
                isSignatureSaved2: true,
                isSignatureSaveFlag2: true,
            });
        } else {
            toastError("Please save Client signature!");
        }
    };

    // exit Operations Signature
    oppSignatureRef2 = React.createRef();
    clearOppSignature2 = () => {
        this.oppSignatureRef2.current.clear();
        this.setState({
            oppIsSignatureSaved2: false,
        });
    };
    clearOppSaveSignatureImg2 = () => {
        this.setState({
            oppExitSignatureData: "",
            oppIsSignatureSaved2: false,
            oppIsSignatureSaveFlag2: false,
        });
    };
    saveOppSignature2 = () => {
        const exitSignatureData = this.oppSignatureRef2.current.toDataURL();
        if (this.oppSignatureRef2.current.isEmpty() == false) {
            this.setState({
                oppExitSignatureData: exitSignatureData,
                oppIsSignatureSaved2: true,
                oppIsSignatureSaveFlag2: true,
            });
        } else {
            toastError("Please fill Opearation signature!");
        }
    };

    downloadNoDue(OrderID, OrderNo) {
        const { userId } = this.state;
        this.setState({ isLoading: true });
        if (OrderID) {
            console.log(OrderID, OrderNo);
            const formattedOrderNo = OrderNo.replace(/[\/-]/g, "_");
            this.props
                .download_no_due_action(userId, OrderID, formattedOrderNo)
                .then((downloadData) => {
                    if (downloadData.error !== 1) {
                        this.setState({ isLoading: false });
                        console.log(downloadData);
                        const url = `${downloadReport}?SessionIdentifier=${downloadData}`;
                        const win = window.open(url, "_blank", 'noopener,noreferrer');
                        if (win != null) {
                            win.focus();
                        }
                    } else {
                        if (downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage) {
                            //after session expire.....................
                            sessionStorage.clear()
                            this.props.navigate('/login')
                            setTimeout(() => {
                                toast.error(downloadData.msg, {
                                    position: "top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                });
                            }, 500);
                        } else {
                            this.setState({ isLoading: false });
                            toastError(downloadData.msg);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                });
        } else {
            this.setState({ isLoading: false });
            toastError("Cannot download: OrderID not found.");
        }
    }

    downloadExitPass(OrderID, OrderNo) {
        const { userId } = this.state;
        this.setState({ isLoading: true });
        if (OrderID) {
            console.log(OrderID, OrderNo);
            const formattedOrderNo = OrderNo.replace(/[\/-]/g, "_");
            this.props
                .download_exitPass_action(userId, OrderID, formattedOrderNo)
                .then((downloadData) => {
                    if (downloadData.error !== 1) {
                        this.setState({ isLoading: false });
                        console.log(downloadData);
                        const url = `${downloadReport}?SessionIdentifier=${downloadData}`;
                        window.open(url, "_blank", 'noopener,noreferrer');
                    } else {
                        if (downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage) {
                            //after session expire.....................
                            sessionStorage.clear()
                            this.props.navigate('/normalView')
                            setTimeout(() => {
                                toast.error(downloadData.msg, {
                                    position: "top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                });
                            }, 500);
                        } else {
                            this.setState({ isLoading: false });
                            toast.error(downloadData.msg, {
                                position: "top-center", theme: "colored",
                                autoClose: 1000, hideProgressBar: true
                            });
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                });
        } else {
            this.setState({ isLoading: false });
            toast.error("Cannot download: OrderID not found.", {
                position: "top-center", theme: "colored",
                autoClose: 1000, hideProgressBar: true
            });
        }
    }

    possessionCheckListAllSelected(e) {
        const { possessionDataListFlag, possessionCheckList } = this.state
        if (!possessionDataListFlag) {
            if (e.target.checked == true) {
                possessionCheckList.map((item) => {
                    item.IsSelected = 1
                })
            } else {
                possessionCheckList.map((item) => {
                    item.IsSelected = 0
                })
            }
            this.setState({ possessionCheckListAllSelected: e.target.checked })
        } else {
            this.setState({ possessionCheckListAllSelected: true })
        }
    }
    exitAdditionalChargeWaveOff(e) {
        const { exitAddChargesWaveOff, isExitClientSubmitted, existDataListFlag } = this.state;
        if (!existDataListFlag && !isExitClientSubmitted) {
            this.setState({
                exitAddChargesWaveOff: e.target.checked
            })
        } else {
            this.setState({
                exitAddChargesWaveOff: false
            })
        }

    }
    exitCheckListAllSelected(e) {
        const { existDataListFlag, exitInstructionList } = this.state
        if (!existDataListFlag) {
            if (e.target.checked == true) {
                exitInstructionList.map((item) => {
                    item.IsSelected = 1
                })
            } else {
                exitInstructionList.map((item) => {
                    item.IsSelected = 0
                })
            }
            this.setState({ exitCheckListAllSelected: e.target.checked })
        } else {
            this.setState({ exitCheckListAllSelected: true })
        }
    }

    vendorCheckboxSelect(i, e) {
        const { exitVendorList, existDataListFlag } = this.state
        const event = e.target.checked
        console.log("sagar-------", event)
        exitVendorList.map((data, index) => {
            if (i == index) {
                if (!existDataListFlag) {
                    if (event) {
                        data.IsClearanceGiven = 1
                    } else {
                        data.IsClearanceGiven = 0
                    }
                }
            }
        })
        this.setState({ exitVendorList: exitVendorList })
    }

    possessionConsumableCheckbox(i, e) {
        const { possessionConsumableList, possessionDataListFlag } = this.state
        const event = e.target.checked
        possessionConsumableList.map((data, index) => {
            if (i == index) {
                if (!possessionDataListFlag) {
                    if (event) {
                        data.IsSelected = 1
                    } else {
                        data.IsSelected = 0
                    }
                }
            }
        })

        const allSelectConsumable = possessionConsumableList.every(item => item.IsSelected == 1)
        if (allSelectConsumable) {
            this.setState({ possessionConsumableAllSelect: true })
        } else {
            this.setState({ possessionConsumableAllSelect: false })
        }
        this.setState({ possessionConsumableList: possessionConsumableList })
    }

    exitConsumableCheckbox(i, e) {
        const { exitConsumableList, existDataListFlag } = this.state
        const event = e.target.checked
        exitConsumableList.map((data, index) => {
            if (i == index) {
                if (!existDataListFlag) {
                    if (event) {
                        data.IsSelected = 1
                    } else {
                        data.IsSelected = 0
                    }
                }
            }
        })
        const allSelect = exitConsumableList.every(item => item.IsSelected == 1)
        if (allSelect) {
            this.setState({ exitConsumableAllSelect: true })
        } else {
            this.setState({ exitConsumableAllSelect: false })
        }
        this.setState({ exitConsumableList: exitConsumableList })
    }


    vendorContactDetails(e, i) {
        const { exitVendorList } = this.state
        const event = e.target.value
        console.log("sagar-------contact details", event)
        exitVendorList.map((data, index) => {
            if (i == index) {
                if (event != '') {
                    data.ContactDetails = event
                } else {
                    data.ContactDetails = ''
                }
            }
        })
        this.setState({ exitVendorList: exitVendorList })
    }

    onElectricityExit(e) {
        const { electricityExitErrMsg, electricityPossesion } = this.state
        const event = e.target.value.replace(/\D/, "");
        if (event != '') {
            this.setState({ electricityExit: parseInt(e.target.value) })
            if (event >= electricityPossesion) {
                this.setState({ electricityExitErrMsg: '' })
            } else {
                this.setState({ electricityExitErrMsg: 'Exit electricity unit must be greater than equal to Possession electricity unit' })
            }
        } else {
            this.setState({ electricityExit: '' })
        }
    }

    // possession
    toggleCollapse(isCollapsed, index) {
        const { possessionMaterialNameAndServiceName } = this.state

        // const $content = $('#collapseContent');

        possessionMaterialNameAndServiceName.map((item, i) => {
            if (i === index) {
                if (!isCollapsed) {
                    item.isCollapsed = true
                } else {
                    item.isCollapsed = false
                }
            } else {
                item.isCollapsed = false
            }
        })

        this.setState({ possessionMaterialNameAndServiceName: possessionMaterialNameAndServiceName })
    };

    possessionMaterialCheckbox(index, e) {
        const { possessionMaterialList, possessionDataListFlag } = this.state;
        const cList = [...possessionMaterialList];
        const event = e.target.checked

        cList.forEach((data, i) => {
            if (i === index) {
                if (event) {
                    if (possessionDataListFlag == true) {
                        data.IsSelected = 0;
                    } else {
                        data.IsSelected = 1;
                        data.PossessionQuantity = 1;
                    }
                } else {
                    if (possessionDataListFlag == true) {
                        data.IsSelected = 1;
                    } else {
                        data.IsSelected = 0;
                        data.PossessionQuantity = "";
                    }
                }
            }
        })

        this.setState({
            possessionMaterialList: cList,
        });
    }

    possessionMaterialQuantity(index, e) {
        const { possessionMaterialList } = this.state;
        const cList = [...possessionMaterialList];
        const event = e.target.value.replace(/\D/, "");
        console.log("event---", event)

        cList.forEach((data, i) => {
            if (i === index) {
                if (event != '') {
                    if (event <= data.Quantity) {
                        data.PossessionQuantity = event
                    } else {
                        toastError(`Max quantity is ${data.Quantity}`)
                        data.PossessionQuantity = ''
                    }
                } else {
                    data.PossessionQuantity = ''
                }
            }
        })

        this.setState({
            possessionMaterialList: cList,
        });
    }

    possessionSecurityListCheckbox(index, e) {
        const { possessionSecurityList, possessionDataListFlag } = this.state;
        const cList = [...possessionSecurityList];
        const event = e.target.checked

        cList.forEach((data, i) => {
            if (i === index) {
                if (event) {
                    if (possessionDataListFlag == true) {
                        data.IsSelected = 0;
                    } else {
                        data.IsSelected = 1;
                    }
                } else {
                    if (possessionDataListFlag == true) {
                        data.IsSelected = 1;
                    } else {
                        data.IsSelected = 0;
                    }
                }
            }
        })

        this.setState({
            possessionSecurityList: cList,
        });
    }

    onPossessionVendorPackageNote(e, index) {
        const { possessionMaterialNameAndServiceName } = this.state;
        const cList = [...possessionMaterialNameAndServiceName];
        const event = e.target.value;
        console.log("event---", event)

        cList.forEach((data, i) => {
            if (i === index) {
                if (event != '') {
                    data.Note = event
                } else {
                    data.Note = ''
                }
            }
        })

        this.setState({
            possessionMaterialNameAndServiceName: cList,
        });
    }

    onExitVendorPackageNote(e, index) {
        const { exitMaterialNameAndServiceName } = this.state;
        const cList = [...exitMaterialNameAndServiceName];
        const event = e.target.value;
        console.log("event---", event)

        cList.forEach((data, i) => {
            if (i === index) {
                if (event != '') {
                    data.Note = event
                } else {
                    data.Note = ''
                }
            }
        })

        this.setState({
            exitMaterialNameAndServiceName: cList,
        });
    }

    // exit
    toggleCollapse2(isCollapsed, index) {
        const { exitMaterialNameAndServiceName } = this.state

        // const $content = $('#collapseContent');

        exitMaterialNameAndServiceName.map((item, i) => {
            if (i === index) {
                if (!isCollapsed) {
                    item.isCollapsed = true
                } else {
                    item.isCollapsed = false
                }
            } else {
                item.isCollapsed = false
            }
        })

        this.setState({ exitMaterialNameAndServiceName: exitMaterialNameAndServiceName })
    };

    exitMaterialCheckbox(index, e) {
        const { exitMaterialList, existDataListFlag } = this.state;
        const cList = [...exitMaterialList];
        const event = e.target.checked

        cList.forEach((data, i) => {
            if (i === index) {
                if (event) {
                    if (existDataListFlag == true) {
                        data.IsSelected = 0;
                    } else {
                        data.IsSelected = 1;
                        data.PossessionQuantity = 1;
                    }
                } else {
                    if (existDataListFlag == true) {
                        data.IsSelected = 1;
                    } else {
                        data.IsSelected = 0;
                        data.PossessionQuantity = "";
                    }
                }
            }
        })

        this.setState({
            exitMaterialList: cList,
        });
    }

    exitMaterialQuantity(index, e) {
        const { exitMaterialList } = this.state;
        const cList = [...exitMaterialList];
        const event = e.target.value.replace(/\D/, "");
        console.log("event---", event)

        cList.forEach((data, i) => {
            if (i === index) {
                if (event != '') {
                    if (event <= data.Quantity) {
                        data.PossessionQuantity = event
                    } else {
                        toastError(`Max quantity is ${data.Quantity}`)
                        data.PossessionQuantity = ''
                    }
                } else {
                    data.PossessionQuantity = ''
                }
            }
        })

        this.setState({
            exitMaterialList: cList,
        });
    }
    exitSecurityChecklistCheckAll(e) {
        const { exitSecurityList, existDataListFlag } = this.state
        const event = e.target.checked
        exitSecurityList.map((item) => {
            if (!existDataListFlag) {
                if (event) {
                    item.IsSelected = 1
                    this.setState({ exitSecurityChecklistCheckAll: true })
                } else {
                    item.IsSelected = 0
                    this.setState({ exitSecurityChecklistCheckAll: false })
                }
            }
        })
        this.setState({ exitSecurityList: exitSecurityList })
    }
    exitSecurityListCheckbox(index, e) {
        const { exitSecurityList, existDataListFlag } = this.state;
        const cList = [...exitSecurityList];
        const event = e.target.checked

        cList.forEach((data, i) => {
            if (i === index) {
                if (event) {
                    if (existDataListFlag == true) {
                        data.IsSelected = 0;
                    } else {
                        data.IsSelected = 1;
                    }
                } else {
                    if (existDataListFlag == true) {
                        data.IsSelected = 1;
                    } else {
                        data.IsSelected = 0;
                    }
                }
            }
        })

        this.setState({
            exitSecurityList: cList,
        });
    }

    possessionServiceCheckAll(e) {
        const { possessionIncludedServicesList, possessionDataListFlag } = this.state
        const event = e.target.checked
        possessionIncludedServicesList.map((item) => {
            if (!possessionDataListFlag) {
                if (event) {
                    item.IsSelected = true
                    item.Quantity = 1
                    this.setState({ possServiceCheckAll: true })
                } else {
                    item.IsSelected = false
                    item.Quantity = ''
                    this.setState({ possServiceCheckAll: false })
                }
            }
        })
        this.setState({ possessionIncludedServicesList: possessionIncludedServicesList })
    }
    exitServiceCheckAll(e) {
        const { exitIncludedServicesList, existDataListFlag } = this.state
        const event = e.target.checked
        exitIncludedServicesList.map((item) => {
            if (!existDataListFlag) {
                if (event) {
                    item.IsSelected = 1
                    item.Quantity = 1
                    this.setState({ exitServiceCheckAll: true })
                } else {
                    item.IsSelected = 0
                    item.Quantity = ''
                    this.setState({ exitServiceCheckAll: false })
                }
            }
        })
        this.setState({ exitIncludedServicesList: exitIncludedServicesList })
    }



    onAdditionalHour(e) {
        const { exitInhouseServicesList } = this.state
        const event = e.target.value.replace(/\D/, "")
        var sumOfAddtionalAmount = 0
        var sumOfAddtionalQauntityAmount = 0
        exitInhouseServicesList.map(item => {
            if (item.IsSelected) {
                sumOfAddtionalAmount += item.Amount
                sumOfAddtionalQauntityAmount += item.AdditionalAmount != undefined ? item.AdditionalAmount : 0
            }
        })
        if (event != '') {
            const amount = this.additionalHrsCalculation(sumOfAddtionalAmount, sumOfAddtionalQauntityAmount, event)
            this.setState({ additionalHrsCalculationAmount: amount });
        } else {
            const amount = this.additionalHrsCalculation(sumOfAddtionalAmount, sumOfAddtionalQauntityAmount, 0)
            this.setState({ additionalHrsCalculationAmount: amount });
        }

        this.setState({ AdditionHours: event })

        setTimeout(() => {
            console.log("additionalHrsCalculationAmount--", this.state.additionalHrsCalculationAmount)
        }, 500);
    }

    possConsumableAllSelectCheckbox(e) {
        const { possessionConsumableList, possessionDataListFlag } = this.state
        possessionConsumableList.map((item) => {
            if (!possessionDataListFlag) {
                if (e.target.checked) {
                    item.IsSelected = true
                    this.setState({ possessionConsumableAllSelect: true })
                } else {
                    item.IsSelected = false
                    this.setState({ possessionConsumableAllSelect: false })
                }
            }
        })
        this.setState({ possessionConsumableList: possessionConsumableList })
    }
    exitConsumableAllSelectCheckbox(e) {
        const { exitConsumableList, existDataListFlag } = this.state
        exitConsumableList.map((item) => {
            if (!existDataListFlag) {
                if (e.target.checked) {
                    item.IsSelected = true
                    this.setState({ exitConsumableAllSelect: true })
                } else {
                    item.IsSelected = false
                    this.setState({ exitConsumableAllSelect: false })
                }
            }
        })
        this.setState({ exitConsumableList: exitConsumableList })
    }

    render() {
        const {
            stateId,
            countryId,
            firstName,
            lastName,
            designation,
            companyName,
            addressLine1,
            addressLine2,
            cityId,
            pincode,
            Mobile1,
            Mobile2,
            exitConsumableAllSelect,
            ISD,
            primaryEmailID,
            secondaryEmailID,
            website,
            TelephoneNumber,
            companyStatusId,
            companyStatusList,
            showCountryId,
            isLoading,
            isAccordionExpanded,
            MyOrdersData,
            possessionSignatureData,
            isSignatureSaved,
            isSignatureSaveFlag,
            possessionIncludedServicesList,
            possessionInhouseServicesList,
            exitAddChargesWaveOff,
            exitAddChargesWaveOffRemark,
            EntryType,
            TypeOfEvent,
            SittingArrangement,
            bookingList,
            PossesionStartDate,
            PossesionEndDate,
            PossesionStartTime,
            PossesionEndTime,
            eventStartDate,
            eventEndDate,
            eventStartTime,
            eventEndTime,
            dismantleStartDate,
            dismantleEndDate,
            dismantleStartTime,
            dismantleEndTime,

            exitIncludedServicesList,
            exitInhouseServicesList,
            exitInstructionList,
            ExitSignatureData,
            isSignatureSaved2,
            isSignatureSaveFlag2,
            possessionDataListFlag,
            unlistedAddServices,
            existDataListFlag,
            isSecurityReceipt,
            noDueCertificate,
            exitPass,
            possessionCheckList,
            PossesionSubmittedUser,
            PossesionSubmittedDate,
            ExitSubmittedUser,
            ExitSubmittedDate,
            exitSub,
            possessionSub,
            possessionCheckListAllSelected,
            exitCheckListAllSelected,
            AdditionHours, BookingEventDataList,
            exitVendorList,
            possessionVendorList, possServiceCheckAll,
            preTel, AreaCode, countryName, possessionTime, exitTime,
            electricityPossesion, electricityExit, electricityExitErrMsg, PossessionContactNameAndNumber, ExitContactNameAndNumber, possessionConsumableList, exitConsumableList, possessionMaterialList, possessionMaterialNameAndServiceName, possessionSecurityList, exitMaterialList, exitMaterialNameAndServiceName, exitSecurityList, PossessionSecurityChecklistNote, ExitSecurityChecklistNote, exitServiceCheckAll,
            oppIsSignatureSaveFlag2, oppIsSignatureSaved2, oppExitSignatureData, ExitOperationNameContact,
            oppIsSignatureSaveFlag, oppIsSignatureSaved, oppPossessionSignatureData, PosssesionOperationNameContact,
            possessionConsumableAllSelect, isExitClientSubmitted, oldAsAmount, piSendShow, OrderNo, ProformaInvoiceID,
            ProformaInvoice_No,
            OrderID, exitSecurityChecklistCheckAll, piFilePath, taxInvoiceFilePath, exitPiFilePath
        } = this.state;

        return (
            <>
                {isLoading ?
                    <Loader></Loader> : false
                }
                <>
                    <main id="main">
                        <Header data={[24]} />
                        <div className="thankYou_page">
                            <div className="thankYou_page_content">
                                {MyOrdersData.length > 0 &&
                                    MyOrdersData.map((data) => (
                                        <div className="card product">
                                            <div className="card-header">
                                                <div className="order_no_and_date">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            {/* {console.log("sagar----------", data)} */}
                                                            <p>Order No : {data.OrderNo}</p>
                                                            <p>Order Date : {data.orderDate}</p>
                                                        </div>
                                                        <div className="col-md-6 text-right" style={{ marginTop: '7px' }}>
                                                            <div>
                                                                {
                                                                    isSecurityReceipt != 0 ?
                                                                        <button class="btn btn-success btn-sm fs-12"
                                                                            style={{ marginRight: '10px', padding: '7px', cursor: 'default' }}
                                                                        >
                                                                            <i class="fa fa-check"></i>
                                                                            <span style={{ fontSize: '13px', marginLeft: '5px' }}>Security Deposit Received</span>
                                                                        </button> :
                                                                        <button class=" exit_pass_btn btn-sm fs-12" style={{ cursor: 'default', marginRight: '10px', backgroundColor: '#cbc6c6', color: '#6c6969', border: 'none', padding: '7px' }}>
                                                                            <i class="fa fa-x"></i><span style={{ fontSize: '13px', marginLeft: '5px' }}>Security Deposit Not Received</span>
                                                                        </button>
                                                                }
                                                                {
                                                                    noDueCertificate != 0 ?
                                                                        <button class="btn btn-warning btn-sm fs-12"
                                                                            onClick={() =>
                                                                                this.downloadNoDue(
                                                                                    this.props.location.state.OrderID,
                                                                                    this.props.location.state.OrderNo
                                                                                )
                                                                            }
                                                                            style={{ marginRight: '10px', padding: '7px' }}>
                                                                            {" "}
                                                                            <i class="fa fa-certificate"></i> <span style={{ fontSize: '13px' }}>No Due
                                                                                Certificate</span>
                                                                        </button> :
                                                                        <button class="exit_pass_btn btn-sm fs-12" style={{ cursor: 'default', marginRight: '10px', backgroundColor: '#cbc6c6', color: '#6c6969', border: 'none', padding: '7px' }}>
                                                                            {" "}
                                                                            <i class="fa fa-certificate"></i> <span style={{ fontSize: '13px' }}>No Due
                                                                                Certificate</span>
                                                                        </button>
                                                                }
                                                                {
                                                                    exitPass != 0 ?
                                                                        <button class="btn btn-success btn-sm fs-12"
                                                                            onClick={() =>
                                                                                this.downloadExitPass(
                                                                                    this.props.location.state.OrderID,
                                                                                    this.props.location.state.OrderNo
                                                                                )
                                                                            }
                                                                            style={{ marginRight: '10px', padding: '7px' }}
                                                                        >
                                                                            <i class="fa fa-download"></i> <span style={{ fontSize: '13px', marginLeft: '5px' }}>Exit Pass</span>
                                                                        </button> :
                                                                        <button class=" exit_pass_btn btn-sm fs-12" style={{ cursor: 'default', marginRight: '10px', backgroundColor: '#cbc6c6', color: '#6c6969', border: 'none', padding: '7px' }}>
                                                                            <i class="fa fa-download"></i><span style={{ fontSize: '13px', marginLeft: '5px' }}>Exit Pass</span>
                                                                        </button>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="search_accordion search_card">
                                                    <div className="panel-group" id="accordion">
                                                        <div className="panel panel-default">
                                                            <div
                                                                className="panel-heading accordion-toggle collapsed"
                                                                data-toggle="collapse"
                                                                data-parent="#accordion"
                                                                data-target="#collapseOne"
                                                                aria-expanded={isAccordionExpanded}
                                                                onClick={() =>
                                                                    this.setState({
                                                                        isAccordionExpanded: !isAccordionExpanded,
                                                                    })
                                                                }
                                                            >
                                                                <h4 className="panel-title">
                                                                    Organizer Details
                                                                </h4>
                                                            </div>
                                                            <div
                                                                id="collapseOne"
                                                                className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                                                                    }`}
                                                                aria-labelledby="headingOne"
                                                            >
                                                                <div className="panel-body">
                                                                    <div className="card-body">
                                                                        <div class="company_info">
                                                                            <fieldset class={"saveAsAbove_section"}>
                                                                                <legend>
                                                                                    Name and Address of the Organizer
                                                                                </legend>

                                                                                <div class="outside_input_field ">
                                                                                    <div class="row">
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group floating-group floating-diff">
                                                                                                <label>
                                                                                                    Category
                                                                                                </label>
                                                                                                <select
                                                                                                    id="state"
                                                                                                    name="Entry Type"
                                                                                                    class="form-control floating-control"
                                                                                                    value={companyStatusId}
                                                                                                    disabled={true}
                                                                                                    style={{ background: "#FAFAFA" }}
                                                                                                >
                                                                                                    <option>Select</option>
                                                                                                    {companyStatusList.length >
                                                                                                        0 &&
                                                                                                        companyStatusList.map(
                                                                                                            (item) => (
                                                                                                                <option
                                                                                                                    key={
                                                                                                                        item.CompanyStatusID
                                                                                                                    }
                                                                                                                    value={
                                                                                                                        item.CompanyStatusID
                                                                                                                    }
                                                                                                                >
                                                                                                                    {item.Name}
                                                                                                                </option>
                                                                                                            )
                                                                                                        )}
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row">
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={firstName}
                                                                                                        type="text"
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        onChange={(e) =>
                                                                                                            this.firstName(e)
                                                                                                        }
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        First Name
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={lastName}
                                                                                                        type="text"
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        onChange={(e) =>
                                                                                                            this.lastName(e)
                                                                                                        }
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        Last Name
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={designation}
                                                                                                        type="text"
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        onChange={(e) =>
                                                                                                            this.designation(e)
                                                                                                        }
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        Designation
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row">
                                                                                        <div class="col-md-12">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={companyName}
                                                                                                        type="text"
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        onChange={(e) =>
                                                                                                            this.organizerName(e)
                                                                                                        }
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        organizer Name
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row">
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group floating-group floating-diff">
                                                                                                <input
                                                                                                    value={countryName}
                                                                                                    type="text"
                                                                                                    class="outside"
                                                                                                    disabled={true}
                                                                                                    autocomplete="off"
                                                                                                />
                                                                                                <span class="floating-label-outside">
                                                                                                    Country Name
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={stateId}
                                                                                                        type="text"
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        onChange={(e) =>
                                                                                                            this.onStateSearch(e)
                                                                                                        }
                                                                                                        autocomplete="off"
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        State Name
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={cityId}
                                                                                                        type="text"
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        onChange={(e) =>
                                                                                                            this.onCitytSearch(e)
                                                                                                        }
                                                                                                        autocomplete="off"
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        City Name
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row">
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={addressLine1}
                                                                                                        type="text"
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        onChange={(e) =>
                                                                                                            this.addressLine1(e)
                                                                                                        }
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        Address Line 1
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={addressLine2}
                                                                                                        type="text"
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        onChange={(e) =>
                                                                                                            this.addressLine2(e)
                                                                                                        }
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        Address Line 2
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={pincode}
                                                                                                        type="text"
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        onChange={(e) =>
                                                                                                            this.pincode(e)
                                                                                                        }
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        {showCountryId == 1 ||
                                                                                                            showCountryId == "" ||
                                                                                                            showCountryId ==
                                                                                                            "Country*"
                                                                                                            ? "Pincode"
                                                                                                            : "ZipCode"}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row">
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="tel_number">
                                                                                                    <div class="ISD">
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            class="outside xy"
                                                                                                            placeholder="ISD"
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            value={ISD}
                                                                                                            disabled={true}
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div class="position-relative width_80">
                                                                                                        <input
                                                                                                            value={Mobile1}
                                                                                                            type="text"
                                                                                                            class="outside"
                                                                                                            disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) =>
                                                                                                                this.mobile1(e)
                                                                                                            }
                                                                                                            maxLength={10}
                                                                                                        />
                                                                                                        <span class="floating-label-outside">
                                                                                                            Mobile 1
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="tel_number">
                                                                                                    <div class="ISD">
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            class="outside"
                                                                                                            placeholder="ISD"
                                                                                                            disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            value={ISD}
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div class="position-relative width_80">
                                                                                                        <input
                                                                                                            value={Mobile2}
                                                                                                            type="text"
                                                                                                            class="outside"
                                                                                                            disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) =>
                                                                                                                this.mobile2(e)
                                                                                                            }
                                                                                                            maxLength={10}
                                                                                                        />
                                                                                                        <span class="floating-label-outside">
                                                                                                            Mobile 2
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="tel_number">
                                                                                                    <div class="ISD">
                                                                                                        <input type="text" class="outside" placeholder={countryId == '91' || countryId == '' || countryId == 'Country*' ? 'STD' : 'ISD'}
                                                                                                            value={preTel} required
                                                                                                            // onChange={(e) => this.preTelephone(e)}
                                                                                                            maxLength={5}
                                                                                                            disabled={true}
                                                                                                        />
                                                                                                    </div>
                                                                                                    {countryId != '91' && countryId != '' && countryId != 'Country*' ?
                                                                                                        <div class="ISD">
                                                                                                            <input type="text" class="outside" placeholder="CODE" value={AreaCode} required
                                                                                                                // onChange={(e) => this.areaCode(e)}
                                                                                                                maxLength={10}
                                                                                                                disabled={true}
                                                                                                            />
                                                                                                        </div>
                                                                                                        : <></>}
                                                                                                    <div class="position-relative width_80">
                                                                                                        <input type="text" class="outside" value={TelephoneNumber} required
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            // onChange={(e) => this.telephone(e)}
                                                                                                            maxLength={16}
                                                                                                            disabled={true}
                                                                                                        />
                                                                                                        <span class="floating-label-outside">Telephone Number</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row">
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={primaryEmailID}
                                                                                                        type="text"
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        onChange={(e) =>
                                                                                                            this.primaryEmail(e)
                                                                                                        }
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        Primary Email ID
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={secondaryEmailID}
                                                                                                        type="text"
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        onChange={(e) =>
                                                                                                            this.secondaryEmail(e)
                                                                                                        }
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        Secondary Email ID{" "}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <div class="position-relative">
                                                                                                    <input
                                                                                                        value={website}
                                                                                                        type="text"
                                                                                                        class="outside"
                                                                                                        disabled={true}
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        onChange={(e) =>
                                                                                                            this.website(e)
                                                                                                        }
                                                                                                    />
                                                                                                    <span class="floating-label-outside">
                                                                                                        Website{" "}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </fieldset>
                                                                            {/* 
                                                                                <fieldset class={"saveAsAbove_section"}>
                                                                                    <legend>Billing Address</legend>

                                                                                    <div class="outside_input_field" >
                                                                                        <div class="row">
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={SAAFirstName} type="text"
                                                                                                            class="outside" disabled={true}
                                                                                                            onChange={(e) => this.setState({ SAAFirstName: e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1), SAAFirstNameErr: '' })}

                                                                                                        />
                                                                                                        <span class="floating-label-outside">First Name</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={SAALastName}
                                                                                                            type="text"
                                                                                                            class="outside" disabled={true}
                                                                                                            onChange={(e) => this.setState({ SAALastName: e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1), SAALastNameErr: '' })}

                                                                                                        />

                                                                                                        <span class="floating-label-outside">Last Name</span>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input type="text" value={SAADesignation} class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ SAADesignation: e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1) })}

                                                                                                        />

                                                                                                        <span class="floating-label-outside">Designation </span>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="row">
                                                                                            <div class="col-md-12">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={SAACompanyName} type="text" class="outside" disabled={true}

                                                                                                            onChange={(e) => this.setState({ SAACompanyName: e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1), SAACompanyNameErr: '' })}
                                                                                                        />
                                                                                                        <span class="floating-label-outside">organizer Name</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="row">

                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group floating-group floating-diff">
                                                                                                    <input value={SAACountryName} type="text"
                                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                        class="outside" disabled={true}
                                                                                                        onChange={(e) => this.onSAAStateSearch(e)}
                                                                                                        autocomplete="off"
                                                                                                    />
                                                                                                    <span class="floating-label-outside">Country Name</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={SAAStateId} type="text"
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            class="outside" disabled={true}
                                                                                                            onChange={(e) => this.onSAAStateSearch(e)}
                                                                                                            autocomplete="off"
                                                                                                        />
                                                                                                        <span class="floating-label-outside">State Name</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={SAACityName} type="text"
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            class="outside" disabled={true}
                                                                                                            autocomplete="off"

                                                                                                        />
                                                                                                        <span class="floating-label-outside">City Name</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="row">
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={SAAAddressLine1} type="text" class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ SAAAddressLine1: e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1), SAAAddressLine1Err: '' })}

                                                                                                        />

                                                                                                        <span class="floating-label-outside">Address Line 1</span>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input type="text" value={SAAAddressLine2} class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ SAAAddressLine2: e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1), SAAAddressLine2Err: '' })}

                                                                                                        />

                                                                                                        <span class="floating-label-outside">Address Line 2</span>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={SAAPincode} type="text" class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ SAAPincode: e.target.value.replace(/\D/, ''), SAAPincodeErr: '' })}

                                                                                                        />

                                                                                                        <span class="floating-label-outside">
                                                                                                            {
                                                                                                                SAACountryId == 1 || SAACountryId == '' || SAACountryId == 'Country*' ? 'Pincode' : 'ZipCode'
                                                                                                            }
                                                                                                        </span>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="row">
                                                                                            <div class="col-md-4">

                                                                                                <div class="form-group">
                                                                                                    <div class="tel_number">
                                                                                                        <div class="ISD">
                                                                                                            <input type="text" class="outside" placeholder="ISD" disabled={true}
                                                                                                                value={SAAISD}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div class="position-relative width_80">
                                                                                                            <input value={SAAMobile1} type="text" class="outside" disabled={true}
                                                                                                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                onChange={(e) => this.setState({ SAAMobile1: e.target.value.replace(/\D/, ''), SAAMobile1Err: '' })}
                                                                                                                maxLength={10}

                                                                                                            />
                                                                                                            <span class="floating-label-outside">Mobile 1</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>


                                                                                            </div>
                                                                                            <div class="col-md-4">

                                                                                                <div class="form-group">
                                                                                                    <div class="tel_number">
                                                                                                        <div class="ISD">
                                                                                                            <input type="text" class="outside" placeholder="ISD" disabled={true}
                                                                                                                value={SAAISD}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div class="position-relative width_80">
                                                                                                            <input value={SAAMobile2} type="text" class="outside" disabled={true}
                                                                                                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                onChange={(e) => this.setState({ SAAMobile2: e.target.value.replace(/\D/, '') })}
                                                                                                                maxLength={10}

                                                                                                            />

                                                                                                            <span class="floating-label-outside">Mobile 2 </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="tel_number">
                                                                                                        <div class="ISD">
                                                                                                            <input type="text" class="outside"
                                                                                                                // onKeyDown={(e) => this.handleKeyDown(e)} 
                                                                                                                placeholder="ISD" value={SAAISD} disabled={true}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div class="position-relative width_80">
                                                                                                            <input value={SAATelephoneNumber}
                                                                                                                // onKeyDown={(e) => this.handleKeyDown(e)} 
                                                                                                                type="text" class="outside" disabled={true}
                                                                                                                onChange={(e) => this.setState({ SAATelephoneNumber: e.target.value.replace(/\D/, '') })}

                                                                                                            />
                                                                                                            <span class="floating-label-outside">Telephone Number </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="row">
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input type="text" value={SAAPrimaryEmailID} class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ SAAPrimaryEmailID: e.target.value, SAAPrimaryEmailIDErr: '' })}

                                                                                                        />

                                                                                                        <span class="floating-label-outside">Primary Email ID</span>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={SAASecondaryEmailID} type="text" class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ SAASecondaryEmailID: e.target.value })}

                                                                                                        />

                                                                                                        <span class="floating-label-outside">Secondary Email ID </span>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={SAAWebsite} type="text" class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ SAAWebsite: e.target.value })}

                                                                                                        />

                                                                                                        <span class="floating-label-outside">Website </span>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </fieldset>
                                                                                {
                                                                                    showCountryId == 1 ?
                                                                                        <fieldset class={"saveAsAbove_section"}>
                                                                                            <legend>Organizer's Information</legend>
                                                                                            <div class="outside_input_field ">
                                                                                                <div class="row">
                                                                                                    <div class="col-md-4">
                                                                                                        <div class="form-group">
                                                                                                            <div class="position-relative">
                                                                                                                <input value={registrationNumber} type="text" class="outside" disabled={true}
                                                                                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                    onChange={(e) => this.setState({ registrationNumber: e.target.value.toUpperCase() })}
                                                                                                                />
                                                                                                                <span class="floating-label-outside">Registration Number </span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div class="col-md-4">
                                                                                                        <div class="form-group">
                                                                                                            <div class="position-relative">
                                                                                                                <input value={PANCardNo} type="text" class="outside" disabled={true}
                                                                                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                    onChange={(e) => this.setState({ PANCardNo: e.target.value.toUpperCase(), PANCardNoErr: '' })}
                                                                                                                />
                                                                                                                <span class="floating-label-outside">PAN Card No.</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div class="col-md-4">
                                                                                                        <div class="form-group">
                                                                                                            <div class="position-relative">
                                                                                                                <input value={NameonPANCard} type="text" class="outside" disabled={true}
                                                                                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                    onChange={(e) => this.setState({ NameonPANCard: e.target.value.toUpperCase(), NameonPANCardErr: '' })}
                                                                                                                />
                                                                                                                <span class="floating-label-outside">Name on PAN Card</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="row">
                                                                                                    <div class="col-md-4">
                                                                                                        <div class="form-group">
                                                                                                            <div class="position-relative">
                                                                                                                <input value={GSTNo} type="text" class="outside" disabled={true}
                                                                                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                    onChange={(e) => this.setState({ GSTNo: e.target.value.toUpperCase() })}
                                                                                                                />
                                                                                                                <span class="floating-label-outside">GST No. </span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div class="col-md-4">
                                                                                                        <div class="form-group">
                                                                                                            <div class="position-relative">
                                                                                                                <input value={TANNumber} type="text" class="outside" disabled={true}
                                                                                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                    onChange={(e) => this.setState({ TANNumber: e.target.value.toUpperCase() })}
                                                                                                                />
                                                                                                                <span class="floating-label-outside">TAN Number </span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div class="col-md-4">
                                                                                                        <div class="form-group">
                                                                                                            <div class="position-relative">
                                                                                                                <input value={UINNumber} type="text" class="outside" disabled={true}
                                                                                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                    onChange={(e) => this.setState({ UINNumber: e.target.value.toUpperCase() })}
                                                                                                                />
                                                                                                                <span class="floating-label-outside">UIN Number </span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                        </fieldset>
                                                                                        : <></>
                                                                                }
                                                                                <fieldset class={"saveAsAbove_section"}>
                                                                                    <legend>Banking details</legend>
                                                                                    <div class="outside_input_field ">
                                                                                        <div class="row">
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={accountName} type="text" class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ accountName: e.target.value.toUpperCase(), accountNameErr: '' })}
                                                                                                        />
                                                                                                        <span class="floating-label-outside">Account Name</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={accountNo} type="text" class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ accountNo: e.target.value.replace(/\D/, ''), accountNoErr: '' })}
                                                                                                        />
                                                                                                        <span class="floating-label-outside">Account No.</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group floating-group floating-diff">
                                                                                                    <input value={accountType} type="text" class="outside" disabled={true}
                                                                                                    />
                                                                                                    <span class="floating-label-outside">Bank name</span>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="row">
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={bankName} type="text" class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ bankName: e.target.value.toUpperCase(), bankNameErr: '' })}
                                                                                                        />
                                                                                                        <span class="floating-label-outside">Bank name</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={branchName} type="text" class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ branchName: e.target.value.toUpperCase(), branchNameErr: '' })}
                                                                                                        />
                                                                                                        <span class="floating-label-outside">branch name</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                    <div class="position-relative">
                                                                                                        <input value={IFSCCode} type="text" class="outside" disabled={true}
                                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                            onChange={(e) => this.setState({ IFSCCode: e.target.value.toUpperCase(), IFSCCodeErr: '' })}
                                                                                                        />
                                                                                                        <span class="floating-label-outside">IFSC code</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </fieldset> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className="d-flex align-items-center gap-2 text-muted"
                                                    style={{ justifyContent: "space-between" }}
                                                >
                                                    <div>
                                                        <h5 className="text-truncate head_text">
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="text-dark"
                                                            >
                                                                {data.centerName}
                                                            </a>
                                                        </h5>
                                                        <p className="text-muted Address_para">
                                                            <i className="fa fa-map-marker" />
                                                            &emsp;{data.centerAdd}
                                                        </p>
                                                    </div>

                                                    {/* ) : null} */}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-8 col-sm-12">
                                                    <div className="card-body order_edit_css">
                                                        <div className=" gy-3">
                                                            <legend>Rentals</legend>
                                                            <fieldset>
                                                                <div className="slot_para">
                                                                    <h6>Summary</h6>
                                                                    <div className="row mr_0">
                                                                        <div className="col-md-4 padding_0">
                                                                            <span>
                                                                                <strong>Type of Event</strong>
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-4 padding_0">
                                                                            <span>
                                                                                <strong>Seating Arrangement</strong>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mr_0">
                                                                        <div className="col-md-4 padding_0">
                                                                            <span>
                                                                                {TypeOfEvent
                                                                                    ? TypeOfEvent
                                                                                    : "Not Available"}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-4 padding_0">
                                                                            <span>
                                                                                {SittingArrangement
                                                                                    ? SittingArrangement
                                                                                    : "Not Available"}
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    <hr />
                                                                    <div className="row mr_0">
                                                                        <div className="col-md-4 padding_0">
                                                                            <span>
                                                                                <strong>Booking Date</strong>
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-3 padding_0">
                                                                            <span>
                                                                                <strong>Booking Slot</strong>
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                <strong>Selected Hrs</strong>
                                                                            </span>
                                                                        </div>
                                                                        {/* <div className="col-md-3 padding_0 text-right">
                                                                            <span>
                                                                                <strong>Amount</strong>
                                                                            </span>
                                                                        </div> */}
                                                                    </div>

                                                                    {data.summary.map((summaryItem, index) => (
                                                                        <div key={index} className="row mr_0">
                                                                            <div className="col-md-4 padding_0">
                                                                                <span>
                                                                                    {this.formatDate(
                                                                                        summaryItem.BookingDate
                                                                                    )}
                                                                                </span>
                                                                            </div>
                                                                            <div className="col-md-3 padding_0">
                                                                                <span>{summaryItem.BookingSlot}</span>
                                                                            </div>
                                                                            <div className="col-md-2 padding_0 text-center">
                                                                                <span>{summaryItem.Selectedhrs}</span>
                                                                            </div>
                                                                            {/* <div className="col-md-3 padding_0 text-right">
                                                                                <span>
                                                                                    {data.currency == "INR" ? "₹" : "$"}{" "}
                                                                                    {summaryItem.NetAmount.toLocaleString(
                                                                                        "en-IN"
                                                                                    )}
                                                                                </span>
                                                                            </div> */}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className="add_service_para" style={{ margin: '1rem' }}>
                                                                    <h6></h6>
                                                                    <div className="row mr_0">
                                                                        <div className="col-md-4 padding_0">
                                                                            <span>
                                                                                <strong>Dates</strong>
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                <strong>Start Date</strong>
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                <strong>End Date</strong>
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                <strong>Start Time</strong>
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                <strong>End Time</strong>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mr_0">
                                                                        {/* <div className="col-md-4 padding_0">
                                                                            <span>Possession Date</span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                {this.formatDate(
                                                                                    PossesionStartDate
                                                                                        ? PossesionStartDate
                                                                                        : "--"
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                {this.formatDate(
                                                                                    PossesionEndDate
                                                                                        ? PossesionEndDate
                                                                                        : "--"
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                {PossesionStartTime
                                                                                    ? PossesionStartTime
                                                                                    : "--"}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                {PossesionEndTime
                                                                                    ? PossesionEndTime
                                                                                    : "--"}
                                                                            </span>
                                                                        </div> */}
                                                                        {BookingEventDataList.map((eventData, index) => (
                                                                            <React.Fragment key={index}>
                                                                                <div className="col-md-4 padding_0">
                                                                                    <span>Event Date</span>
                                                                                </div>
                                                                                <div className="col-md-2 padding_0 text-center">
                                                                                    <span>
                                                                                        {eventData.EventStartDate
                                                                                            ? moment(eventData.EventStartDate, 'DD/MM/YYYY').format('MMMM DD, YYYY')
                                                                                            : "--"}

                                                                                    </span>
                                                                                </div>
                                                                                <div className="col-md-2 padding_0 text-center">
                                                                                    <span>
                                                                                        {eventData.EventEndDate
                                                                                            ? moment(eventData.EventEndDate, 'DD/MM/YYYY').format('MMMM DD, YYYY')
                                                                                            : "--"}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="col-md-2 padding_0 text-center">
                                                                                    <span>{eventData.EventStartTime ? eventData.EventStartTime : "--"}</span>
                                                                                </div>
                                                                                <div className="col-md-2 padding_0 text-center">
                                                                                    <span>{eventData.EventEndTime ? eventData.EventEndTime : "--"}</span>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        ))}
                                                                        {/* <div className="col-md-4 padding_0">
                                                                            <span>Dismantle Date</span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                {this.formatDate(
                                                                                    dismantleStartDate
                                                                                        ? dismantleStartDate
                                                                                        : "--"
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                {this.formatDate(
                                                                                    dismantleEndDate
                                                                                        ? dismantleEndDate
                                                                                        : "--"
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                {dismantleStartTime
                                                                                    ? dismantleStartTime
                                                                                    : "--"}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-md-2 padding_0 text-center">
                                                                            <span>
                                                                                {dismantleEndTime
                                                                                    ? dismantleEndTime
                                                                                    : "--"}
                                                                            </span>
                                                                        </div> */}
                                                                    </div>
                                                                </div>
                                                            </fieldset>
                                                            {/* <div className="add_service_para">
                                <h6>Additional Services</h6>
                                <div className="row mr_0">
                                  <div className="col-md-4 padding_0">
                                    <span>
                                      <strong>Services</strong>
                                    </span>
                                  </div>
                                  <div className="col-md-3 padding_0">
                                    <span>
                                      <strong>Type</strong>
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      <strong>Quantity</strong>
                                    </span>
                                  </div>
                                  <div className="col-md-3 padding_0 text-right">
                                    <span>
                                      <strong>Amount (INR)</strong>
                                    </span>
                                  </div>
                                </div>
                                {data.additionalServices.map(
                                  (service, index) => (
                                    <div key={index} className="row mr_0">
                                      {service.Services ? (
                                         <>
                                      <div className="col-md-4 padding_0">
                                        <span>{service.Services}</span>
                                      </div>
                                      <div className="col-md-3 padding_0">
                                        <span>
                                          {service.Type == "S"
                                            ? "Standard"
                                            : "Premium"}
                                        </span>
                                      </div>
                                      <div className="col-md-2 padding_0 text-center">
                                        <span>{service.Quantity}</span>
                                      </div>
                                      <div className="col-md-3 padding_0 text-right">
                                        <span>
                                          {data.currency == "INR" ? "₹" : "$"}{" "}
                                          {service.GrossAmount?.toLocaleString(
                                            "en-IN"
                                          )}
                                        </span>
                                      </div>
                                      </>):null}
                                    </div>
                                  )
                                )}
                              </div> */}
                                                        </div>
                                                    </div>
                                                    {/* <div className="card-footer">
                                                            <div className="align-items-center gy-3">
                                                                <div className="">
                                                                    <div
                                                                        className="d-flex align-items-center gap-2 text-muted"
                                                                        style={{ justifyContent: "space-between" }}
                                                                    >
                                                                        <div className="width_100 my_color">
                                                                            Price
                                                                        </div>
                                                                        <h5 className="fs-14 mb-0 my_color">
                                                                            {data.currency == "INR" ? "₹" : "$"}
                                                                            <span className="product-line-price">
                                                                                {data.Price?.NetAmount?.toLocaleString(
                                                                                    "en-IN"
                                                                                )}
                                                                            </span>
                                                                        </h5>
                                                                    </div>
                                                                    <div
                                                                        className="d-flex align-items-center gap-2 text-muted"
                                                                        style={{ justifyContent: "space-between" }}
                                                                    >
                                                                        <div className="width_100 my_color">
                                                                            GST ( 18% )
                                                                        </div>
                                                                        <h5 className="fs-14 mb-0 my_color">
                                                                            {data.currency == "INR" ? "₹" : "$"}
                                                                            <span className="product-line-price">
                                                                                {data.Price?.GST?.toLocaleString("en-IN")}
                                                                            </span>
                                                                        </h5>
                                                                    </div>
                                                                    <div
                                                                        className="d-flex align-items-center gap-2 text-muted"
                                                                        style={{ justifyContent: "space-between" }}
                                                                    >
                                                                        <div className="width_100 my_color">
                                                                            Deposit
                                                                        </div>
                                                                        <h5 className="fs-14 mb-0 my_color">
                                                                            {data.currency == "INR" ? "₹" : "$"}
                                                                            <span className="product-line-price">
                                                                                {parseInt(
                                                                                    data.Price?.SecurityDeposit
                                                                                )?.toLocaleString("en-IN")}
                                                                            </span>
                                                                        </h5>
                                                                    </div>
                                                                    <hr
                                                                        style={{
                                                                            margin: "5px 0px",
                                                                            borderTop: "1px dashed rgba(0,0,0,.1)",
                                                                        }}
                                                                    />
                                                                    <div
                                                                        className="d-flex align-items-center gap-2 text-muted"
                                                                        style={{ justifyContent: "space-between" }}
                                                                    >
                                                                        <div className="width_100 my_color">
                                                                            <b>Total</b>
                                                                        </div>
                                                                        <h5 className="fs-14 mb-0 my_color">
                                                                            {data.currency == "INR" ? "₹" : "$"}
                                                                            <span className="product-line-price">
                                                                                <b>
                                                                                    {data.Price?.Total?.toLocaleString(
                                                                                        "en-IN"
                                                                                    )}
                                                                                </b>
                                                                            </span>
                                                                        </h5>
                                                                    </div>
                                                                    {console.log(data.proformaDetails)}
                                                                    <div
                                                                        className="d-flex align-items-center gap-2 text-muted"
                                                                        style={{ justifyContent: "space-between" }}
                                                                    >
                                                                        <div className="width_100 my_color">
                                                                            <b>Payment Recieved</b>
                                                                        </div>
                                                                        <h5 className="fs-14 mb-0 my_color">
                                                                            {data.currency == "INR" ? "₹" : "$"}
                                                                            <span className="product-line-price">
                                                                                <b>{data.proformaDetails?.Outstanding?.toLocaleString(
                                                                                    "en-IN"
                                                                                )}</b>
                                                                            </span>
                                                                        </h5>
                                                                    </div>
                                                                    <div
                                                                        className="d-flex align-items-center gap-2 text-muted"
                                                                        style={{ justifyContent: "space-between" }}
                                                                    >
                                                                        <div className="width_100 my_color">
                                                                            <b>Balance</b>
                                                                        </div>
                                                                        <h5 className="fs-14 mb-0 my_color">
                                                                            {data.currency == "INR" ? "₹" : "$"}
                                                                            <span className="product-line-price">
                                                                                <b>
                                                                                    {data.proformaDetails?.Paid?.toLocaleString(
                                                                                        "en-IN"
                                                                                    )}
                                                                                </b>
                                                                            </span>
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                </div>
                                                <div className="col-md-4" />
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                        {
                            noDueCertificate == 1 ?
                                <div className="thankYou_page" style={{ marginTop: '0px' }}>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h6 class="mb-0">Possession</h6>
                                                </div>
                                                <div class="card-body">
                                                    <div class="company_info">
                                                        <h6 style={{ color: "#35b3e6" }}>
                                                            {" "}Possession Time
                                                        </h6>
                                                        <table
                                                            class="table table-bordered table-striped table-sm"
                                                            id="tbl" style={{ width: "50%", height: '40px' }}
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th>Possession time :</th>
                                                                    <th style={{ width: '40%' }}>
                                                                        {moment(possessionTime).utc().format("DD/MM/YYYY hh:mm:ss")}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                        </table>

                                                        <h6 style={{ color: "#35b3e6" }}>Inhouse Services</h6>
                                                        <table
                                                            class="table table-bordered table-striped table-sm"
                                                            id="tbl"
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ width: "10px" }}>
                                                                        <div class="bg only_checkbox">
                                                                            <div class="chiller_cb">
                                                                                <input
                                                                                    checked={possServiceCheckAll}
                                                                                    onClick={(e) =>
                                                                                        this.possessionServiceCheckAll(e)
                                                                                    }
                                                                                    id={`possServiceCheckAll`}
                                                                                    type="checkbox"
                                                                                />
                                                                                <label
                                                                                    className="lebel-dis"
                                                                                    for={`possServiceCheckAll`}
                                                                                    style={{ color: "#979797" }}
                                                                                >
                                                                                    &nbsp;
                                                                                </label>
                                                                                <span></span>
                                                                            </div>
                                                                        </div>
                                                                    </th>
                                                                    <th>Services</th>
                                                                    <th
                                                                        class="text-center"
                                                                        style={{ width: "15%" }}
                                                                    >
                                                                        Quantity
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {possessionIncludedServicesList.length > 0 &&
                                                                    possessionIncludedServicesList != null ? (
                                                                    possessionIncludedServicesList.map(
                                                                        (data, i) => (
                                                                            <tr>
                                                                                <td>
                                                                                    <div class="bg only_checkbox">
                                                                                        <div class="chiller_cb">
                                                                                            <input
                                                                                                checked={data.IsSelected}
                                                                                                onClick={(e) =>
                                                                                                    this.possessionIncludedCheckbox(
                                                                                                        i,
                                                                                                        data.IsSelected,
                                                                                                        e
                                                                                                    )
                                                                                                }
                                                                                                id={`ServiceCheck1${i}`}
                                                                                                type="checkbox"
                                                                                            />
                                                                                            <label
                                                                                                className="lebel-dis"
                                                                                                for={`ServiceCheck1${i}`}
                                                                                                style={{ color: "#979797" }}
                                                                                            >
                                                                                                &nbsp;
                                                                                            </label>
                                                                                            <span></span>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ verticalAlign: 'middle' }}>
                                                                                    <div>{data.InclusiveServices}</div>
                                                                                </td>
                                                                                <td class="text-center" >
                                                                                    <input
                                                                                        style={{ textAlign: 'center' }}
                                                                                        type="text"
                                                                                        value={data.Quantity}
                                                                                        onChange={(e) =>
                                                                                            this.ispossessionIncludedQuantity(
                                                                                                e,
                                                                                                i,
                                                                                                data.Name
                                                                                            )
                                                                                        }
                                                                                        onBlur={(e) => this.onBlurIspossessionIncludedQuantity(e,
                                                                                            i,
                                                                                            data.Name)}
                                                                                        maxLength={3}
                                                                                        disabled={
                                                                                            !data.IsSelected || possessionDataListFlag
                                                                                        }
                                                                                        class="form-control coustome-checkbox"
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    )
                                                                ) : (
                                                                    <tr>
                                                                        <td
                                                                            colSpan={6}
                                                                            className="text-center"
                                                                            style={{ color: "#F96302" }}
                                                                        >
                                                                            Record not found
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>

                                                        <h6 style={{ color: "#35b3e6" }}> Additional Paid Services</h6>
                                                        <table
                                                            class="table table-bordered table-striped table-sm"
                                                            id="tbl"
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ width: "10px" }}></th>
                                                                    <th>Services</th>
                                                                    <th colSpan={1}></th>
                                                                    <th
                                                                        class="text-center"
                                                                    >
                                                                        Quantity
                                                                    </th>
                                                                    {/* <th
                                  class="text-center"
                                  style={{ width: "15%" }}
                                >
                                  Rate
                                </th>
                                <th
                                  class="text-center"
                                  style={{ width: "15%" }}
                                >
                                  Amount (INR)
                                </th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {possessionInhouseServicesList.length > 0 &&
                                                                    possessionInhouseServicesList != null ? (
                                                                    possessionInhouseServicesList.map((data, i) => (
                                                                        <tr>
                                                                            <td>
                                                                                <div class="bg only_checkbox">
                                                                                    <div class="chiller_cb">
                                                                                        <input
                                                                                            id={`ServiceCheck2${i}`}
                                                                                            checked={data.IsSelected}
                                                                                            onClick={(e) =>
                                                                                                this.possessionInhouseCheckbox(
                                                                                                    i,
                                                                                                    data.IsSelected,
                                                                                                    e
                                                                                                )
                                                                                            }
                                                                                            // disabled={true}
                                                                                            type="checkbox"
                                                                                        />
                                                                                        <label
                                                                                            className="lebel-dis"
                                                                                            for={`ServiceCheck2${i}`}
                                                                                            style={{ color: "#979797" }}
                                                                                        >
                                                                                            &nbsp;
                                                                                        </label>
                                                                                        <span></span>

                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            {
                                                                                data.Name != 'Electricity' ?
                                                                                    <td colSpan={2}>
                                                                                        <div>{data.Name}</div>
                                                                                    </td>
                                                                                    :
                                                                                    <td>
                                                                                        Electricity
                                                                                    </td>
                                                                            }
                                                                            {
                                                                                data.Name != 'Electricity' ?
                                                                                    <td class="text-center" style={{ width: "15%" }}>
                                                                                        <input
                                                                                            type="text"
                                                                                            value={data.Quantity}
                                                                                            onChange={(e) =>
                                                                                                this.ispossessionInhouseQuantity(
                                                                                                    e,
                                                                                                    i,
                                                                                                    data.Name
                                                                                                )
                                                                                            }
                                                                                            maxLength={3}
                                                                                            disabled={true}
                                                                                            class="form-control coustome-checkbox"
                                                                                            style={{ textAlign: 'center' }}
                                                                                        />
                                                                                    </td> :
                                                                                    <td colSpan={2} style={{ color: '#212529', marginBottom: '0px' }}>
                                                                                        Electricity rate –RS. 16/- per kwh
                                                                                    </td>
                                                                            }

                                                                            {/* <td class="text-center">
                                      {data.Currency == "INR"
                                        ? data.PriceInINR != "" &&
                                          data.PriceInINR != null
                                          ? data.PriceInINR.toLocaleString(
                                              "en-IN"
                                            )
                                          : null
                                        : data.PriceInUSD}
                                    </td>

                                    <td class="text-center">
                                      {data.IsSelected == 1
                                        ? data.Amount != "" &&
                                          data.Amount != null
                                          ? data.Amount.toLocaleString("en-IN")
                                          : data.Currency == "INR"
                                          ? data.PriceInINR != "" &&
                                            data.PriceInINR != null
                                            ? data.PriceInINR.toLocaleString(
                                                "en-IN"
                                              )
                                            : null
                                          : data.PriceInUSD
                                        : "-"}
                                    </td> */}
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td
                                                                            colSpan={6}
                                                                            className="text-center"
                                                                            style={{ color: "#F96302" }}
                                                                        >
                                                                            Record not found
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <h6 style={{ color: "#35b3e6" }}>External Services</h6>
                                                    <table
                                                        class="table table-bordered table-striped table-sm"
                                                        id="tbl"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th>Service</th>
                                                                <th>Vendor</th>
                                                                {/* <th>Contact Details</th> */}
                                                                {/* <th>Clearance</th> */}
                                                            </tr>
                                                        </thead >
                                                        <tbody>
                                                            {possessionVendorList != '' && possessionVendorList.length > 0 ?
                                                                possessionVendorList.map((data, i) => (
                                                                    <tr>
                                                                        <td>{data.Service}</td>
                                                                        <td>{data.Vendor}</td>
                                                                        {/* <td>{data.PackageName}</td> */}
                                                                        {/* <td>
                                                                                        <div class="chiller_cb" style={{}}>
                                                                                            <input
                                                                                                id={`possVendorCheckboxSelect`}
                                                                                                checked={data.IsClearanceGiven}
                                                                                                // onClick={(e) => this.vendorCheckboxSelect(e, i)}
                                                                                                // disabled={true}
                                                                                                type="checkbox"
                                                                                            />
                                                                                            <label
                                                                                                for={`possVendorCheckboxSelect`}
                                                                                                style={{ fontSize: '13px', color: '#212529', fontWeight: 'normal' }}
                                                                                            > Select All</label>
                                                                                            <span></span>
                                                                                            <span></span>
                                                                                        </div>
                                                                                    </td> */}
                                                                    </tr>
                                                                ))
                                                                : <tr>
                                                                    <td
                                                                        colSpan={4}
                                                                        className="text-center"
                                                                        style={{ color: "#F96302" }}
                                                                    >
                                                                        Record not found
                                                                    </td>
                                                                </tr>}
                                                        </tbody>
                                                    </table>

                                                    <h6 style={{ color: "#35b3e6" }}>Consumable</h6>
                                                    <table
                                                        class="table table-bordered table-striped table-sm"
                                                        id="tbl"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th >Consumable</th>
                                                                <th style={{ width: '5%' }}>
                                                                    <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                        <div class="chiller_cb" >
                                                                            <input
                                                                                type="checkbox"
                                                                                id={`possessionConsumableAllSelect`}
                                                                                checked={possessionConsumableAllSelect}
                                                                                onClick={(e) => this.possConsumableAllSelectCheckbox(e)}
                                                                            />
                                                                            <label
                                                                                for={`possessionConsumableAllSelect`}
                                                                                style={{ color: "#979797;" }}>&nbsp;</label>
                                                                            <span></span>
                                                                        </div>

                                                                    </div>
                                                                </th>
                                                            </tr>
                                                        </thead >
                                                        <tbody>
                                                            {possessionConsumableList != '' && possessionConsumableList.length > 0 ?
                                                                possessionConsumableList.map((data, i) => (
                                                                    <tr>
                                                                        <td>{data.Name}</td>
                                                                        <td style={{ width: '5%' }}>
                                                                            <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                                <div class="chiller_cb" >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`possessionConsumable${i}`}
                                                                                        checked={data.IsSelected}
                                                                                        onClick={(e) => this.possessionConsumableCheckbox(i, e)}
                                                                                    />
                                                                                    <label
                                                                                        for={`possessionConsumable${i}`}
                                                                                        style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                    <span></span>
                                                                                </div>

                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                                : <tr>
                                                                    <td
                                                                        colSpan={4}
                                                                        className="text-center"
                                                                        style={{ color: "#F96302" }}
                                                                    >
                                                                        Record not found
                                                                    </td>
                                                                </tr>}
                                                        </tbody>
                                                    </table>

                                                    <h6 style={{ color: "#35b3e6" }}>Material List</h6>
                                                    <div className="search_accordion search_card  m-0">
                                                        <div className="panel-group" id="accordion">
                                                            {possessionMaterialNameAndServiceName.length > 0 ?
                                                                possessionMaterialNameAndServiceName.map((item, index) => (
                                                                    <div className="panel panel-default mb-2" style={{ background: '#f3f3f3' }}>
                                                                        <div
                                                                            className="panel-heading accordion-toggle collapsed p-2"
                                                                            data-toggle="collapse"
                                                                            data-parent="#accordion"
                                                                            data-target="#collapseOne"
                                                                            onClick={() => this.toggleCollapse(item.isCollapsed, index)}
                                                                        >

                                                                            <h5 className="panel-title d-flex" style={{ justifyContent: 'space-between' }}>
                                                                                {/* <span className='packages'></span> */}
                                                                                <span className='packages'>{item.VendorName} / {item.ServiceName}</span>
                                                                            </h5>
                                                                        </div>
                                                                        <div id="collapseContent" style={{ display: !item.isCollapsed ? 'none' : 'block' }}>

                                                                            <div className="thankYou_page" style={{ margin: '0px' }}>
                                                                                <div class="row" style={{ padding: '0px 21px 0px 33px' }}>
                                                                                    <table
                                                                                        class="table table-bordered table-material mb-2"
                                                                                        id="tbl"
                                                                                        style={{ background: '#ffff' }}
                                                                                    >
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th style={{ width: '5%' }}></th>
                                                                                                <th >Material Name</th>
                                                                                                <th style={{ width: '15%' }}>Quantity</th>
                                                                                            </tr>
                                                                                        </thead >
                                                                                        <tbody>
                                                                                            {
                                                                                                possessionMaterialList != '' && possessionMaterialList.length > 0 ?
                                                                                                    possessionMaterialList.map((data, i) => (
                                                                                                        <>
                                                                                                            {
                                                                                                                data.VendorID == item.VendorID ?
                                                                                                                    <tr>
                                                                                                                        <td style={{ width: '5%' }}>
                                                                                                                            <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                                                                                <div class="chiller_cb" >
                                                                                                                                    <input
                                                                                                                                        type="checkbox"
                                                                                                                                        id={`possessionMaterial${i}`}
                                                                                                                                        checked={data.IsSelected}

                                                                                                                                        onClick={(e) => this.possessionMaterialCheckbox(i, e)}
                                                                                                                                    />
                                                                                                                                    <label
                                                                                                                                        for={`possessionMaterial${i}`}
                                                                                                                                        style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                                                                    <span></span>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </td>
                                                                                                                        <td>{data.MaterialName}</td>
                                                                                                                        <td>
                                                                                                                            <input type="text" className="form-control coustome-checkbox"
                                                                                                                                disabled={!data.IsSelected || possessionDataListFlag}
                                                                                                                                value={data.PossessionQuantity}
                                                                                                                                onChange={(e) => this.possessionMaterialQuantity(i, e)}
                                                                                                                            />
                                                                                                                        </td>
                                                                                                                    </tr>
                                                                                                                    : <></>
                                                                                                            }
                                                                                                        </>
                                                                                                    ))
                                                                                                    : <tr>
                                                                                                        <td
                                                                                                            colSpan={4}
                                                                                                            className="text-center"
                                                                                                            style={{ color: "#F96302" }}
                                                                                                        >
                                                                                                            Record not found
                                                                                                        </td>
                                                                                                    </tr>}
                                                                                        </tbody>
                                                                                    </table>
                                                                                    <div class="form-group w-100 mb-3">
                                                                                        <h6 style={{ color: "#35b3e6", margin: '0px' }}>Note:</h6>
                                                                                        <textarea maxLength={500}
                                                                                            value={item.Note}
                                                                                            onChange={(e) => this.onPossessionVendorPackageNote(e, index)}
                                                                                            style={{ height: '80px' }}
                                                                                            disabled={possessionDataListFlag}
                                                                                            class="form-control" rows="3" placeholder="Type here..."></textarea>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                ))
                                                                :
                                                                <table
                                                                    class="table table-bordered table-striped table-sm"
                                                                    id="tbl"
                                                                >
                                                                    <tbody>
                                                                        <td style={{ color: "#F96302", textAlign: 'center' }}>Record not found</td>
                                                                    </tbody>
                                                                </table>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* <h6 style={{ color: "#35b3e6", marginTop: '20px' }}>Center Security List</h6>
                                                    <table
                                                        class="table table-bordered table-striped table-sm"
                                                        id="tbl"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th colSpan={2}>Center Security List</th>
                                                            </tr>
                                                        </thead >
                                                        <tbody>
                                                            {possessionSecurityList != '' && possessionSecurityList.length > 0 ?
                                                                possessionSecurityList.map((data, i) => (
                                                                    <tr>
                                                                        <td>{data.Name}</td>
                                                                        <td style={{ width: '5%' }}>
                                                                            <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                                <div class="chiller_cb" >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`possessionSecurityList${i}`}
                                                                                        checked={data.IsSelected}
                                                                                        onClick={(e) => this.possessionSecurityListCheckbox(i, e)}
                                                                                    />
                                                                                    <label
                                                                                        for={`possessionSecurityList${i}`}
                                                                                        style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                    <span></span>
                                                                                </div>

                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                                : <tr>
                                                                    <td
                                                                        colSpan={4}
                                                                        className="text-center"
                                                                        style={{ color: "#F96302" }}
                                                                    >
                                                                        Record not found
                                                                    </td>
                                                                </tr>}
                                                        </tbody>
                                                    </table> */}


                                                    {/* <h6 style={{ color: "#35b3e6", marginTop: '20px' }}>Security List Note:</h6>
                                                    <div class="row">
                                                        <div class="col-md-12" style={{ padding: '0 15px' }}>
                                                            <div class="form-group">
                                                                <textarea maxLength={500}
                                                                    value={PossessionSecurityChecklistNote}
                                                                    onChange={(e) => this.setState({ PossessionSecurityChecklistNote: e.target.value })}
                                                                    style={{ height: '150px' }}
                                                                    disabled={possessionDataListFlag}
                                                                    class="form-control" rows="3" placeholder="Type here..."></textarea>
                                                            </div>
                                                        </div>
                                                    </div> */}

                                                    <h6 style={{ color: "#35b3e6", marginTop: '20px' }}>Electricity</h6>
                                                    <table
                                                        class="table table-bordered table-striped table-sm"
                                                        id="tbl"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th>Electricity Units Reading on Possesion</th>
                                                                <th style={{ width: '20%' }}>
                                                                    <input
                                                                        style={{ textAlign: 'center' }}
                                                                        disabled={possessionDataListFlag}
                                                                        value={electricityPossesion}
                                                                        onChange={(e) => this.setState({ electricityPossesion: e.target.value.replace(/\D/, "") != '' ? parseInt(e.target.value.replace(/\D/, "")) : '' })}
                                                                        type="text"
                                                                        maxLength={10}
                                                                        class="form-control coustome-checkbox"
                                                                    /></th>
                                                            </tr>
                                                        </thead>
                                                    </table>

                                                    <div class="Checklist_div mb-3" style={{ marginTop: '30px' }}>
                                                        <div className="bg checklist">
                                                            <div class="chiller_cb" style={{}}>
                                                                <input
                                                                    id={`possessionCheckListAllSelected`}
                                                                    checked={possessionCheckListAllSelected}
                                                                    onClick={(e) => this.possessionCheckListAllSelected(e)}
                                                                    // disabled={ possessionDataListFlag }
                                                                    type="checkbox"
                                                                />
                                                                <label
                                                                    for={`possessionCheckListAllSelected`}
                                                                    style={{ fontSize: '13px', color: '#212529', fontWeight: 'normal' }}
                                                                > Select All</label>
                                                                <span></span>
                                                                <span></span>
                                                            </div>
                                                        </div>
                                                        {possessionCheckList.length > 0 &&
                                                            possessionCheckList != null ? (
                                                            possessionCheckList.map((data, i) => (
                                                                <><div className="bg checklist">
                                                                    <div class="chiller_cb" style={{ marginLeft: '10px' }}>
                                                                        <input
                                                                            id={`possessionCheckList${i}`}
                                                                            checked={data.IsSelected}
                                                                            onClick={(e) =>
                                                                                this.possessionCheckList(
                                                                                    i,
                                                                                    data.IsSelected,
                                                                                    e
                                                                                )
                                                                            }
                                                                            // disabled={true}
                                                                            type="checkbox"
                                                                        />
                                                                        <label
                                                                            for={`possessionCheckList${i}`}
                                                                            style={{ fontSize: '13px', color: '#212529', fontWeight: 'normal' }}
                                                                        >
                                                                            {data.Name}<span class="mendatory_class" style={{ marginLeft: "18px", border: 'none' }}>*</span>
                                                                        </label>
                                                                        <span></span>
                                                                        <span></span>
                                                                    </div>
                                                                </div>
                                                                </>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td
                                                                    colSpan={6}
                                                                    className="text-center"
                                                                    style={{ color: "#F96302" }}
                                                                >
                                                                    Record not found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </div>

                                                    <div
                                                        class="d-flex align-items-center"
                                                        style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                                    >
                                                        <div className="d-flex">
                                                            <div>
                                                                <label>Contact Name And Number<span class="mendatory_class">*</span></label>
                                                                <textarea
                                                                    value={PossessionContactNameAndNumber}
                                                                    disabled={possessionDataListFlag}
                                                                    onChange={(e) => this.setState({ PossessionContactNameAndNumber: e.target.value })}
                                                                    style={{ resize: 'none', height: '100px' }}
                                                                    className="form-control"
                                                                    cols={100}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="d-flex">
                                                            <div>
                                                                <label>Client Signature<span class="mendatory_class">*</span></label>
                                                                <div
                                                                    class="client_signature_box"
                                                                    style={{ border: "1px solid #c9c8c8" }}
                                                                >
                                                                    {isSignatureSaved || possessionDataListFlag ? (
                                                                        <img
                                                                            src={possessionSignatureData}
                                                                            style={{ width: 250, height: 125 }}
                                                                            alt="Saved Signature"
                                                                        />
                                                                    ) : (
                                                                        <div>
                                                                            <SignatureCanvas
                                                                                ref={this.signatureRef}
                                                                                penColor="rgb(126 123 123)"
                                                                                canvasProps={{
                                                                                    width: 250,
                                                                                    height: 120,
                                                                                    className: "signature-canvas",
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {!possessionDataListFlag ? (
                                                                <div style={{ marginTop: "105px" }}>
                                                                    {isSignatureSaveFlag ? (
                                                                        <button
                                                                            onClick={this.clearSaveSignatureImg}
                                                                            class="btn btn-secondary m-1"
                                                                        >
                                                                            Clear
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            onClick={this.clearSignature}
                                                                            class="btn btn-secondary m-1"
                                                                        >
                                                                            Clear
                                                                        </button>
                                                                    )}
                                                                    {isSignatureSaveFlag ? (
                                                                        <></>
                                                                    ) : (
                                                                        <button
                                                                            onClick={this.saveSignature}
                                                                            class="btn btn-success"
                                                                        >
                                                                            Save
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="d-flex align-items-center mt-4"
                                                        style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                                    >
                                                        <div className="d-flex">
                                                            <div>
                                                                <label>Operations Contact Name And Number<span class="mendatory_class">*</span></label>
                                                                <textarea
                                                                    value={PosssesionOperationNameContact}
                                                                    disabled={possessionDataListFlag}
                                                                    onChange={(e) => this.setState({ PosssesionOperationNameContact: e.target.value })}
                                                                    style={{ resize: 'none', height: '100px' }}
                                                                    className="form-control"
                                                                    cols={100}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div
                                                        class="d-flex align-items-center"
                                                        style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                                    >
                                                        <div className="d-flex">
                                                            <div>
                                                                <label>Operations Signature<span class="mendatory_class">*</span></label>
                                                                <div
                                                                    class="client_signature_box"
                                                                    style={{ border: "1px solid #c9c8c8" }}
                                                                >
                                                                    {oppIsSignatureSaved || possessionDataListFlag ? (
                                                                        <img
                                                                            src={oppPossessionSignatureData}
                                                                            style={{ width: 250, height: 125 }}
                                                                            alt="Saved Signature"
                                                                        />
                                                                    ) : (
                                                                        <div>
                                                                            <SignatureCanvas
                                                                                ref={this.oppSignatureRef}
                                                                                penColor="rgb(126 123 123)"
                                                                                canvasProps={{
                                                                                    width: 250,
                                                                                    height: 120,
                                                                                    className: "signature-canvas",
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {!possessionDataListFlag ? (
                                                                <div style={{ marginTop: "105px" }}>
                                                                    {oppIsSignatureSaveFlag ? (
                                                                        <button
                                                                            onClick={this.clearOppSaveSignatureImg}
                                                                            class="btn btn-secondary m-1"
                                                                        >
                                                                            Clear
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            onClick={this.clearOppSignature}
                                                                            class="btn btn-secondary m-1"
                                                                        >
                                                                            Clear
                                                                        </button>
                                                                    )}
                                                                    {oppIsSignatureSaveFlag ? (
                                                                        <></>
                                                                    ) : (
                                                                        <button
                                                                            onClick={this.saveOppSignature}
                                                                            class="btn btn-success"
                                                                        >
                                                                            Save
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </div>
                                                        <div style={{ marginTop: "110px", display: 'flex', flexDirection: 'column' }} >
                                                            {!possessionDataListFlag ?
                                                                <>{
                                                                    possessionSub ?
                                                                        <button
                                                                            style={{ width: '100px' }}
                                                                            class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                                                        >
                                                                            Submit
                                                                        </button> :
                                                                        <button
                                                                            style={{ width: '100px' }}
                                                                            class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                                                            onClick={() => this.submitPossessionList()}
                                                                        >
                                                                            Submit
                                                                        </button>
                                                                }
                                                                </>
                                                                : <>
                                                                    <span style={{ color: "#979797" }}>Possession Submitted by {PossesionSubmittedUser}</span>
                                                                    <span style={{ color: "#979797" }}>{moment(PossesionSubmittedDate).utc().format("DD/MM/YYYY hh:mm:ss")}</span>
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {possessionDataListFlag ? (
                                            <div class="col-md-6">
                                                <div class="card">
                                                    <div class="card-header">
                                                        <h6 class="mb-0">Exit</h6>
                                                    </div>
                                                    <div class="card-body" >
                                                        <div class="company_info">
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <h6 style={{ color: "#35b3e6" }}>
                                                                        {" "}
                                                                        Exit Time
                                                                    </h6>
                                                                    <table
                                                                        class="table table-bordered table-striped table-sm"
                                                                        id="tbl" style={{ width: "100%", height: '40px' }}
                                                                    >
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Exit time :</th>
                                                                                <th style={{ width: '40%' }}>
                                                                                    {moment(exitTime).utc().format("DD/MM/YYYY hh:mm:ss")}
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                    </table>
                                                                </div>
                                                                <div className="col-6">
                                                                    <h6 style={{ color: "#35b3e6" }}> Additional hours</h6>
                                                                    <table
                                                                        class="table table-bordered table-striped table-sm"
                                                                        id="tbl" style={{ width: "100%" }}
                                                                    >
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Additional hours Utilized</th>
                                                                                <th style={{ width: '40%' }}>
                                                                                    <input
                                                                                        style={{ textAlign: 'center' }}
                                                                                        disabled={existDataListFlag || isExitClientSubmitted}
                                                                                        value={AdditionHours}
                                                                                        onChange={(e) =>
                                                                                            this.onAdditionalHour(e)}
                                                                                        type="text"
                                                                                        maxLength={3}
                                                                                        class="form-control coustome-checkbox"
                                                                                    />
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <h6 style={{ color: "#35b3e6" }}>Inhouse Services</h6>
                                                            <table
                                                                class="table table-bordered table-striped table-sm"
                                                                id="tbl"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: "10px" }}>
                                                                            <div class="bg only_checkbox">
                                                                                <div class="chiller_cb">
                                                                                    <input
                                                                                        checked={exitServiceCheckAll}
                                                                                        onChange={(e) => {
                                                                                            if (isExitClientSubmitted) { return false } else {
                                                                                                this.exitServiceCheckAll(e)
                                                                                            }
                                                                                        }}
                                                                                        id={`exitServiceCheckAll`}
                                                                                        type="checkbox"
                                                                                    />
                                                                                    <label
                                                                                        className="lebel-dis"
                                                                                        for={`exitServiceCheckAll`}
                                                                                        style={{ color: "#979797" }}
                                                                                    >
                                                                                        &nbsp;
                                                                                    </label>
                                                                                    <span></span>
                                                                                </div>
                                                                            </div>
                                                                        </th>
                                                                        <th>Services</th>
                                                                        <th
                                                                            class="text-center"
                                                                            style={{ width: "15%" }}
                                                                        >
                                                                            Quantity
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {exitIncludedServicesList.length > 0 &&
                                                                        exitIncludedServicesList != null ? (
                                                                        exitIncludedServicesList.map((data, i) => (
                                                                            <tr>
                                                                                <td>
                                                                                    <div class="bg only_checkbox">
                                                                                        <div class="chiller_cb">
                                                                                            <input
                                                                                                checked={data.IsSelected}
                                                                                                onChange={(e) => {
                                                                                                    if (isExitClientSubmitted) { return false } else {
                                                                                                        this.existIncludedCheckbox(
                                                                                                            i,
                                                                                                            data.IsSelected,
                                                                                                            e
                                                                                                        )
                                                                                                    }
                                                                                                }}
                                                                                                id={`existIncludedCheckbox${i}`}
                                                                                                type="checkbox"
                                                                                            />
                                                                                            <label
                                                                                                className="lebel-dis"
                                                                                                for={`existIncludedCheckbox${i}`}
                                                                                                style={{ color: "#979797" }}
                                                                                            >
                                                                                                &nbsp;
                                                                                            </label>
                                                                                            <span></span>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div>{data.InclusiveServices}</div>
                                                                                </td>
                                                                                <td class="text-center" >
                                                                                    <input
                                                                                        type="text"
                                                                                        value={data.Quantity}
                                                                                        onChange={(e) =>
                                                                                            this.exitIncludedQuantity(
                                                                                                e,
                                                                                                i,
                                                                                                data.Name
                                                                                            )
                                                                                        }
                                                                                        onBlur={(e) => this.onBlurIsExitIncludedQuantity(e,
                                                                                            i,
                                                                                            data.Name)}

                                                                                        style={{ textAlign: 'center' }}
                                                                                        maxLength={3}
                                                                                        disabled={!data.IsSelected && !data.Is_checked || existDataListFlag || isExitClientSubmitted}
                                                                                        // disabled={true}
                                                                                        class="form-control coustome-checkbox"
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td
                                                                                colSpan={6}
                                                                                className="text-center"
                                                                                style={{ color: "#F96302" }}
                                                                            >
                                                                                Record not found
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>

                                                            <h6 style={{ color: "#35b3e6" }}> Additional Paid Services</h6>
                                                            <table
                                                                class="table table-bordered table-striped table-sm"
                                                                id="tbl"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: "10px" }}></th>
                                                                        <th>Services</th>
                                                                        <th colSpan={2}></th>
                                                                        <th
                                                                            class="text-center"
                                                                            style={{ width: "15%" }}
                                                                        >
                                                                            Quantity
                                                                        </th>
                                                                        <th
                                                                            class="text-center"
                                                                            style={{ width: "131px" }}
                                                                        >
                                                                            Additional Quantity
                                                                        </th>
                                                                        {/* <th
                                    class="text-center"
                                    style={{ width: "15%" }}
                                  >
                                    Rate
                                  </th>
                                  <th
                                    class="text-center"
                                    style={{ width: "15%" }}
                                  >
                                    Amount (INR)
                                  </th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {exitInhouseServicesList.length > 0 &&
                                                                        exitInhouseServicesList != null ? (
                                                                        exitInhouseServicesList.map((data, i) => (
                                                                            <tr>
                                                                                <td>
                                                                                    <div class="bg only_checkbox">
                                                                                        <div class="chiller_cb">
                                                                                            <input
                                                                                                id={`exitInhouseServicesList${i}`}
                                                                                                checked={data.IsSelected || data.Is_checked}
                                                                                                onChange={(e) => {
                                                                                                    if (isExitClientSubmitted) { return false } else {
                                                                                                        this.ExitInhouseCheckbox(
                                                                                                            i,
                                                                                                            data.IsSelected,
                                                                                                            e,
                                                                                                            data.Name
                                                                                                        )
                                                                                                    }
                                                                                                }}
                                                                                                // disabled={true}
                                                                                                type="checkbox"
                                                                                            />
                                                                                            <label
                                                                                                className="lebel-dis"
                                                                                                for={`exitInhouseServicesList${i}`}
                                                                                                style={{ color: "#979797" }}
                                                                                            >
                                                                                                &nbsp;
                                                                                            </label>
                                                                                            <span></span>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                {
                                                                                    data.Name != 'Electricity' ?
                                                                                        <td colSpan={3}>
                                                                                            <div>{data.Name}</div>
                                                                                        </td> :
                                                                                        <td>
                                                                                            <div>Electricity</div>
                                                                                        </td>
                                                                                }
                                                                                {
                                                                                    data.Name != 'Electricity' ?
                                                                                        <>
                                                                                            <td class="text-center">
                                                                                                <input
                                                                                                    style={{ textAlign: 'center' }}
                                                                                                    type="text"
                                                                                                    value={data.Quantity}
                                                                                                    disabled={true}
                                                                                                    class="form-control coustome-checkbox"
                                                                                                />
                                                                                            </td>
                                                                                        </> :
                                                                                        <td colSpan={3} style={{ color: '#212529', marginBottom: '0px' }}>
                                                                                            Electricity rate –RS. 16/- per kwh
                                                                                        </td>
                                                                                }
                                                                                <td class="text-center">
                                                                                    <input

                                                                                        style={{ textAlign: 'center' }}
                                                                                        type="text"
                                                                                        value={data.AdditionalQuantity}
                                                                                        onChange={(e) => {
                                                                                            if (isExitClientSubmitted) { return false } else {

                                                                                                this.exitInhouseAdditionQuantity(
                                                                                                    e,
                                                                                                    i,
                                                                                                    data.Name
                                                                                                )
                                                                                            }
                                                                                        }
                                                                                        }
                                                                                        onBlur={(e) => this.onBlurExitInhouseAdditionQuantity(e,
                                                                                            i,
                                                                                            data.Name)}
                                                                                        maxLength={3}
                                                                                        disabled={!data.IsSelected && !data.Is_checked || existDataListFlag || isExitClientSubmitted}
                                                                                        class="form-control coustome-checkbox"
                                                                                    />
                                                                                </td>

                                                                                {/* <td class="text-center">
                                        {data.Currency == "INR"
                                          ? data.PriceInINR != "" &&
                                            data.PriceInINR != null
                                            ? data.PriceInINR.toLocaleString(
                                                "en-IN"
                                              )
                                            : null
                                          : data.PriceInUSD}
                                      </td>

                                      <td class="text-center">
                                        {data.IsSelected == 1
                                          ? data.Amount != "" &&
                                            data.Amount != null
                                            ? data.Amount.toLocaleString(
                                                "en-IN"
                                              )
                                            : data.Currency == "INR"
                                            ? data.PriceInINR != "" &&
                                              data.PriceInINR != null
                                              ? data.PriceInINR.toLocaleString(
                                                  "en-IN"
                                                )
                                              : null
                                            : data.PriceInUSD
                                          : "-"}
                                      </td> */}
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td
                                                                                colSpan={6}
                                                                                className="text-center"
                                                                                style={{ color: "#F96302" }}
                                                                            >
                                                                                Record not found
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>



                                                            <h6 style={{ color: "#35b3e6" }}>External Services</h6>
                                                            <table
                                                                class="table table-bordered table-striped table-sm" style={{ zIndex: '000', position: 'relative' }} id="tbl"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th>Service</th>
                                                                        <th>Vendor</th>
                                                                        <th>Contact Details<span class="mendatory_class">*</span></th>
                                                                        <th style={{ width: '5%' }}>Clearance<span class="mendatory_class">*</span></th>
                                                                    </tr>
                                                                </thead >
                                                                <tbody>
                                                                    {exitVendorList != '' && exitVendorList.length > 0 ?
                                                                        exitVendorList.map((data, i) => (
                                                                            <tr>
                                                                                <td>{data.ServiceName}</td>
                                                                                <td>{data.VendorName}</td>
                                                                                <td>
                                                                                    <input
                                                                                        value={data.ContactDetails}
                                                                                        onChange={(e) => this.vendorContactDetails(e, i)}
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        disabled={existDataListFlag || isExitClientSubmitted}
                                                                                        maxLength={500}
                                                                                    />
                                                                                </td>
                                                                                <td >
                                                                                    <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                                        <div class="chiller_cb" >
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={`vendorCheckboxSelect${i}`}
                                                                                                checked={data.IsClearanceGiven}
                                                                                                onClick={(e) => { if (isExitClientSubmitted) { return false } else { this.vendorCheckboxSelect(i, e) } }}
                                                                                            />
                                                                                            <label
                                                                                                for={`vendorCheckboxSelect${i}`}
                                                                                                style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                            <span></span>
                                                                                        </div>

                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                        : <tr>
                                                                            <td
                                                                                colSpan={4}
                                                                                className="text-center"
                                                                                style={{ color: "#F96302" }}
                                                                            >
                                                                                Record not found
                                                                            </td>
                                                                        </tr>}
                                                                </tbody>
                                                            </table>

                                                            <h6 style={{ color: "#35b3e6" }}>Consumable</h6>
                                                            <table
                                                                class="table table-bordered table-striped table-sm"
                                                                id="tbl"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th >Consumable</th>
                                                                        <th style={{ width: '5%' }}>
                                                                            <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                                <div class="chiller_cb" >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`exitConsumableAllSelect`}
                                                                                        checked={exitConsumableAllSelect}
                                                                                        onClick={(e) => {
                                                                                            if (isExitClientSubmitted) { return false } else {
                                                                                                this.exitConsumableAllSelectCheckbox(e)
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                    <label
                                                                                        for={`exitConsumableAllSelect`}
                                                                                        style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                    <span></span>
                                                                                </div>

                                                                            </div>
                                                                        </th>
                                                                    </tr>
                                                                </thead >
                                                                <tbody>
                                                                    {exitConsumableList != '' && exitConsumableList.length > 0 ?
                                                                        exitConsumableList.map((data, i) => (
                                                                            <tr>
                                                                                <td>{data.Name}</td>
                                                                                <td style={{ width: '5%' }}>
                                                                                    <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                                        <div class="chiller_cb" >
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={`exitConsumable${i}`}
                                                                                                checked={data.IsSelected}
                                                                                                onClick={(e) => {
                                                                                                    if (isExitClientSubmitted) { return false } else {
                                                                                                        this.exitConsumableCheckbox(i, e)
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                            <label
                                                                                                for={`exitConsumable${i}`}
                                                                                                style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                            <span></span>
                                                                                        </div>

                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                        : <tr>
                                                                            <td
                                                                                colSpan={4}
                                                                                className="text-center"
                                                                                style={{ color: "#F96302" }}
                                                                            >
                                                                                Record not found
                                                                            </td>
                                                                        </tr>}
                                                                </tbody>
                                                            </table>

                                                            <h6 style={{ color: "#35b3e6" }}>Material List</h6>
                                                            <div className="search_accordion search_card  m-0" >
                                                                <div className="panel-group" id="accordion">
                                                                    {exitMaterialNameAndServiceName.length > 0 ?
                                                                        exitMaterialNameAndServiceName.map((item, index) => (
                                                                            <>
                                                                                <div className="panel panel-default mb-2" style={{ background: '#f3f3f3' }}>
                                                                                    <div
                                                                                        className="panel-heading accordion-toggle collapsed p-2"
                                                                                        data-toggle="collapse"
                                                                                        data-parent="#accordion"
                                                                                        data-target="#collapseOne"
                                                                                        onClick={() => this.toggleCollapse2(item.isCollapsed, index)}
                                                                                    >

                                                                                        <h4 className="panel-title d-flex" style={{ justifyContent: 'space-between' }}>
                                                                                            {/* <span className='packages'></span> */}
                                                                                            <span className='packages'>{item.VendorName} / {item.ServiceName}</span>
                                                                                        </h4>
                                                                                    </div>
                                                                                    <div id="collapseContent" style={{ display: !item.isCollapsed ? 'none' : 'block' }}>

                                                                                        <div className="thankYou_page" style={{ margin: '0px' }}>
                                                                                            <div class="row" style={{ padding: '0px 21px 0px 33px' }}>
                                                                                                <table
                                                                                                    class="table table-bordered table-material"
                                                                                                    id="tbl"
                                                                                                    style={{ background: '#ffff' }}
                                                                                                >
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th style={{ width: '5%' }}></th>
                                                                                                            <th >Material Name</th>
                                                                                                            <th style={{ width: '15%' }}>Quantity</th>
                                                                                                        </tr>
                                                                                                    </thead >
                                                                                                    <tbody>
                                                                                                        {
                                                                                                            exitMaterialList != '' && exitMaterialList.length > 0 ?
                                                                                                                exitMaterialList.map((data, i) => (
                                                                                                                    <>
                                                                                                                        {
                                                                                                                            data.VendorID == item.VendorID ?
                                                                                                                                <tr>
                                                                                                                                    <td style={{ width: '5%' }}>
                                                                                                                                        <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                                                                                            <div class="chiller_cb" >
                                                                                                                                                <input
                                                                                                                                                    type="checkbox"
                                                                                                                                                    id={`exitMaterial${i}`}
                                                                                                                                                    checked={data.IsSelected}
                                                                                                                                                    onClick={(e) => {
                                                                                                                                                        if (isExitClientSubmitted) { return false } else {
                                                                                                                                                            this.exitMaterialCheckbox(i, e)
                                                                                                                                                        }
                                                                                                                                                    }}
                                                                                                                                                />
                                                                                                                                                <label
                                                                                                                                                    for={`exitMaterial${i}`}
                                                                                                                                                    style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                                                                                <span></span>
                                                                                                                                            </div>
                                                                                                                                        </div>
                                                                                                                                    </td>
                                                                                                                                    <td>{data.MaterialName}</td>
                                                                                                                                    <td>
                                                                                                                                        <input type="text" className="form-control coustome-checkbox"
                                                                                                                                            disabled={!data.IsSelected || existDataListFlag || isExitClientSubmitted}
                                                                                                                                            value={data.PossessionQuantity}
                                                                                                                                            onChange={(e) => this.exitMaterialQuantity(i, e)}
                                                                                                                                        />
                                                                                                                                    </td>
                                                                                                                                </tr>
                                                                                                                                : <></>
                                                                                                                        }
                                                                                                                    </>
                                                                                                                ))
                                                                                                                : <tr>
                                                                                                                    <td
                                                                                                                        colSpan={4}
                                                                                                                        className="text-center"
                                                                                                                        style={{ color: "#F96302" }}
                                                                                                                    >
                                                                                                                        Record not found
                                                                                                                    </td>
                                                                                                                </tr>}
                                                                                                    </tbody>
                                                                                                </table>
                                                                                                <div class="form-group w-100 mb-3">
                                                                                                    <h6 style={{ color: "#35b3e6", margin: '0px' }}>Note:</h6>
                                                                                                    <textarea maxLength={500}
                                                                                                        value={item.Note}
                                                                                                        onChange={(e) => this.onExitVendorPackageNote(e, index)}
                                                                                                        style={{ height: '80px' }}
                                                                                                        disabled={existDataListFlag || isExitClientSubmitted}
                                                                                                        class="form-control" rows="3" placeholder="Type here..."></textarea>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>

                                                                            </>
                                                                        ))
                                                                        : <table
                                                                            class="table table-bordered table-striped table-sm"
                                                                            id="tbl"
                                                                        >
                                                                            <tbody>
                                                                                <td style={{ color: "#F96302", textAlign: 'center' }}>Record not found</td>
                                                                            </tbody>
                                                                        </table>
                                                                    }
                                                                </div>
                                                            </div>



                                                            <h6 style={{ color: "#35b3e6" }}>Electricity</h6>
                                                            <table
                                                                class="table table-bordered table-striped table-sm"
                                                                id="tbl"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th>Electricity Units Reading on Exit </th>
                                                                        <th style={{ width: '40%' }}>
                                                                            <input
                                                                                style={{ textAlign: 'center' }}
                                                                                disabled={existDataListFlag || isExitClientSubmitted}
                                                                                value={electricityExit}
                                                                                onChange={(e) => this.onElectricityExit(e)}
                                                                                type="text"
                                                                                maxLength={10}
                                                                                class="form-control coustome-checkbox"
                                                                            />
                                                                            {<span className='text-danger text-start text-left d-block mt-1'>{electricityExitErrMsg}</span>}
                                                                        </th>
                                                                    </tr>

                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Total Consumed units</td>
                                                                        <td style={{ textAlign: 'center' }}>{(electricityExit < electricityPossesion) ? 0 : electricityExit - electricityPossesion}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                            <div class="Checklist_div mb-3" style={{ marginTop: '30px' }}>
                                                                <div className="bg checklist">
                                                                    <div class="chiller_cb" style={{}}>
                                                                        <input
                                                                            id={`exitCheckListAllSelected`}
                                                                            checked={exitCheckListAllSelected}
                                                                            onClick={(e) => {
                                                                                if (isExitClientSubmitted) {
                                                                                    return false
                                                                                } else {
                                                                                    this.exitCheckListAllSelected(e)
                                                                                }
                                                                            }}
                                                                            // disabled={true}
                                                                            type="checkbox"
                                                                        />
                                                                        <label
                                                                            for={`exitCheckListAllSelected`}
                                                                            style={{ fontSize: '13px', color: '#212529', fontWeight: 'normal' }}
                                                                        > Select All</label>
                                                                        <span></span>
                                                                        <span></span>
                                                                    </div>
                                                                </div>
                                                                {exitInstructionList.length > 0 &&
                                                                    exitInstructionList != null ? (
                                                                    exitInstructionList.map((data, i) => (
                                                                        <>
                                                                            <div className="bg checklist" style={{ marginLeft: '10px' }}>
                                                                                <div class="chiller_cb">
                                                                                    <input
                                                                                        id={`exitInstructionCheckbox${i}`}
                                                                                        checked={data.IsSelected}
                                                                                        onClick={(e) => {
                                                                                            if (isExitClientSubmitted) {
                                                                                                return false
                                                                                            } else {

                                                                                                this.exitInstructionCheckbox(
                                                                                                    i,
                                                                                                    data.IsSelected,
                                                                                                    e
                                                                                                )
                                                                                            }
                                                                                        }
                                                                                        }
                                                                                        // disabled={true}
                                                                                        type="checkbox"
                                                                                    />
                                                                                    <label
                                                                                        for={`exitInstructionCheckbox${i}`}
                                                                                        style={{ fontSize: '13px', color: '#212529', fontWeight: 'normal' }}
                                                                                    >
                                                                                        {data.Name}<span class="mendatory_class" style={{ marginLeft: "18px", border: 'none' }}>*</span>
                                                                                    </label>
                                                                                    <span></span>
                                                                                </div>
                                                                            </div>

                                                                            {/* <div className="d-flex">
                                                                        <div class="chiller_cb">
                                                                            <input
                                                                                id={`exitInstructionCheckbox${i}`}
                                                                                checked={data.IsSelected}
                                                                                onClick={(e) =>
                                                                                    this.exitInstructionCheckbox(
                                                                                        i,
                                                                                        data.IsSelected,
                                                                                        e
                                                                                    )
                                                                                }
                                                                                // disabled={true}
                                                                                type="checkbox"
                                                                            />
                                                                            <label
                                                                                for={`exitInstructionCheckbox${i}`}
                                                                                style={{ color: "#979797" }}
                                                                            >
                                                                            </label>
                                                                            <span></span>
                                                                        </div>
                                                                        <div>
                                                                            <span class="mendatory_class">*</span>
                                                                            <span style={{ color: "#979797"}}>{data.Name}</span>
                                                                        </div>
                                                                    </div> */}
                                                                        </>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td
                                                                            colSpan={6}
                                                                            className="text-center"
                                                                            style={{ color: "#F96302" }}
                                                                        >
                                                                            Record not found
                                                                        </td>
                                                                    </tr>
                                                                )}

                                                                <div class="row mt-2">
                                                                    <div className='col-md-12'>
                                                                        <h6 className='additional_services' >Remark</h6>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <div class="form-group">
                                                                            <textarea maxLength={500}
                                                                                value={unlistedAddServices}
                                                                                onChange={(e) => this.setState({ unlistedAddServices: e.target.value })}
                                                                                style={{ height: '180px' }}
                                                                                disabled={existDataListFlag || isExitClientSubmitted}
                                                                                class="form-control" rows="3" placeholder="Type here..."></textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div
                                                                class="d-flex align-items-center"
                                                                style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                                            >
                                                                <div className="d-flex">
                                                                    <div>
                                                                        <label>Client Contact Name And Number<span class="mendatory_class">*</span></label>
                                                                        <textarea
                                                                            value={ExitContactNameAndNumber}
                                                                            disabled={existDataListFlag || isExitClientSubmitted}
                                                                            onChange={(e) => this.setState({ ExitContactNameAndNumber: e.target.value })}
                                                                            style={{ resize: 'none', height: '100px' }}
                                                                            className="form-control"
                                                                            cols={100}
                                                                        />
                                                                    </div>

                                                                </div>
                                                                <div className="d-flex">
                                                                    <div>
                                                                        <label>Client Signature<span class="mendatory_class">*</span></label>
                                                                        <div
                                                                            class="client_signature_box"
                                                                            style={{ border: "1px solid #c9c8c8" }}
                                                                        >
                                                                            {isSignatureSaved2 || existDataListFlag || isExitClientSubmitted ? (
                                                                                <img
                                                                                    src={ExitSignatureData}
                                                                                    style={{ width: 250, height: 125 }}
                                                                                    alt="Saved Signature"
                                                                                />
                                                                            ) : (

                                                                                <div>
                                                                                    <SignatureCanvas
                                                                                        ref={this.signatureRef2}
                                                                                        penColor="rgb(126 123 123)"
                                                                                        canvasProps={{
                                                                                            width: 250,
                                                                                            height: 125,
                                                                                            className: "signature-canvas",
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        !existDataListFlag ?
                                                                            <>
                                                                                {!isExitClientSubmitted ?
                                                                                    <div style={{ marginTop: "105px" }}>
                                                                                        {isSignatureSaveFlag2 || isSignatureSaved2 ? (
                                                                                            <button
                                                                                                onClick={this.clearSaveSignatureImg2}
                                                                                                class="btn btn-secondary m-1"
                                                                                            >
                                                                                                Clear
                                                                                            </button>

                                                                                        ) : (
                                                                                            <button
                                                                                                onClick={this.clearSignature2}
                                                                                                class="btn btn-secondary m-1"
                                                                                            >
                                                                                                Clear
                                                                                            </button>
                                                                                        )}
                                                                                        {isSignatureSaveFlag2 || isSignatureSaved2 ? (
                                                                                            <></>
                                                                                        ) : (
                                                                                            <button
                                                                                                onClick={this.saveSignature2}
                                                                                                class="btn btn-success"
                                                                                            >
                                                                                                Save
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                    : <></>}
                                                                            </>
                                                                            : <></>
                                                                    }
                                                                </div>


                                                            </div>
                                                            <div className="bg checklist" style={{ marginLeft: '10px', marginTop: '2rem' }}>
                                                                <div class="chiller_cb">
                                                                    <input
                                                                        id={`exitInstructionCheckbox`}
                                                                        checked={exitAddChargesWaveOff}
                                                                        onClick={(e) => this.exitAdditionalChargeWaveOff(e)}
                                                                        type="checkbox"
                                                                    />
                                                                    <label
                                                                        for={`exitInstructionCheckbox`}
                                                                        style={{ fontSize: '13px', color: '#212529', fontWeight: 'normal' }}
                                                                    >
                                                                        Additional Charges Wave-Off
                                                                    </label>
                                                                    <span></span>
                                                                </div>{
                                                                    exitAddChargesWaveOff ? (<>
                                                                        <div>
                                                                            <label>Additional Charges Wave-Off Remark<span class="mendatory_class">*</span></label>
                                                                            <textarea
                                                                                value={exitAddChargesWaveOffRemark}
                                                                                disabled={existDataListFlag || isExitClientSubmitted}
                                                                                onChange={(e) => this.setState({ exitAddChargesWaveOffRemark: e.target.value })}
                                                                                style={{ resize: 'none', height: '100px' }}
                                                                                className="form-control"
                                                                                cols={100}
                                                                            />
                                                                        </div>
                                                                    </>) : <></>
                                                                }
                                                                {!existDataListFlag ? <>


                                                                </> : <>
                                                                </>}
                                                                {!isExitClientSubmitted ?
                                                                    <div style={{ marginTop: "10px", display: 'flex', flexDirection: possessionDataListFlag ? '' : 'column', marginBottom: '5px', alignItems: 'flex-end' }} >
                                                                        {!existDataListFlag && !isExitClientSubmitted ?
                                                                            <>
                                                                                <button
                                                                                    // style={{ width: '100px' }}
                                                                                    class="btn btn-warning custom_btn Terms_and_Conditions_btn mr-2"
                                                                                    onClick={() => this.submitExitList(0, 'opp')}
                                                                                >
                                                                                    Save As Draft
                                                                                </button>
                                                                                <button
                                                                                    style={{ width: '100px' }}
                                                                                    class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                                                                    onClick={() => this.clientSubmitExit()}
                                                                                >
                                                                                    Submit
                                                                                </button>
                                                                            </>
                                                                            : <>
                                                                                <>
                                                                                    {/* { !existDataListFlag && !isExitClientSubmitted && <button
                                                                                        // style={{ width: '100px' }}
                                                                                        class="btn btn-warning custom_btn Terms_and_Conditions_btn mr-2"
                                                                                        onClick={() => this.submitExitList(0, 'opp')}
                                                                                    >
                                                                                        Save As Draft
                                                                                    </button>} */}
                                                                                    <button
                                                                                        style={{ width: '100px' }}
                                                                                        class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                                                                        disabled={true}
                                                                                    >
                                                                                        Submitted
                                                                                    </button>
                                                                                </>
                                                                            </>
                                                                        }
                                                                    </div> :
                                                                    <div style={{ marginTop: "10px", display: 'flex', flexDirection: 'row', marginBottom: '5px', alignItems: 'flex-end' }} >
                                                                        {!existDataListFlag &&
                                                                            <>
                                                                                {/* <button
                                                                                // style={{ width: '100px' }}
                                                                                class="btn btn-warning custom_btn Terms_and_Conditions_btn mr-2"
                                                                                onClick={() => this.submitExitList(0, 'opp')}
                                                                            >
                                                                                Save As Draft
                                                                            </button> */}
                                                                                {exitPiFilePath != '' && exitPiFilePath != null && <button
                                                                                    // style={{ width: '100px' }}
                                                                                    class="btn btn-secondary custom_btn Terms_and_Conditions_btn mr-2"
                                                                                    onClick={() => this.openSendPiModal(ProformaInvoiceID,
                                                                                        ProformaInvoice_No,
                                                                                        OrderID, exitPiFilePath, OrderNo)}
                                                                                >
                                                                                    Send PI
                                                                                </button>}
                                                                            </>}
                                                                        <button
                                                                            style={{ width: '100px' }}
                                                                            class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                                                            disabled={true}
                                                                        >
                                                                            Submitted
                                                                        </button>
                                                                    </div>
                                                                }
                                                            </div>

                                                            <h6 style={{ color: "#35b3e6", marginTop: '20px' }}>Center Security List</h6>
                                                            <table
                                                                class="table table-bordered table-striped table-sm"
                                                                id="tbl"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th>Center Security List</th>
                                                                        <th style={{ width: '5%' }}> <div class="bg only_checkbox">
                                                                            <div class="chiller_cb">
                                                                                <input
                                                                                    checked={exitSecurityChecklistCheckAll}
                                                                                    onChange={(e) => {
                                                                                        if (existDataListFlag) { return false } else {
                                                                                            this.exitSecurityChecklistCheckAll(e)
                                                                                        }
                                                                                    }}
                                                                                    id={`exitSecurityChecklistCheckAll`}
                                                                                    type="checkbox"
                                                                                />
                                                                                <label
                                                                                    className="lebel-dis"
                                                                                    for={`exitSecurityChecklistCheckAll`}
                                                                                    style={{ color: "#979797" }}
                                                                                >
                                                                                    &nbsp;
                                                                                </label>
                                                                                <span></span>
                                                                            </div>
                                                                        </div></th>
                                                                    </tr>
                                                                </thead >
                                                                <tbody>
                                                                    {exitSecurityList != '' && exitSecurityList.length > 0 ?
                                                                        exitSecurityList.map((data, i) => (
                                                                            <tr>
                                                                                <td>{data.Name}</td>
                                                                                <td style={{ width: '5%' }}>
                                                                                    <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                                        <div class="chiller_cb" >
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={`exitSecurityList${i}`}
                                                                                                checked={data.IsSelected}
                                                                                                onClick={(e) => this.exitSecurityListCheckbox(i, e)}
                                                                                            />
                                                                                            <label
                                                                                                for={`exitSecurityList${i}`}
                                                                                                style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                            <span></span>
                                                                                        </div>

                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                        : <tr>
                                                                            <td
                                                                                colSpan={4}
                                                                                className="text-center"
                                                                                style={{ color: "#F96302" }}
                                                                            >
                                                                                Record not found
                                                                            </td>
                                                                        </tr>}
                                                                </tbody>
                                                            </table>

                                                            <h6 style={{ color: "#35b3e6", marginTop: '20px' }}>Security List Note:</h6>
                                                            <div class="row">
                                                                <div class="col-md-12" style={{ padding: '0 15px' }}>
                                                                    <div class="form-group">
                                                                        <textarea maxLength={500}
                                                                            value={ExitSecurityChecklistNote}
                                                                            onChange={(e) => this.setState({ ExitSecurityChecklistNote: e.target.value })}
                                                                            style={{ height: '150px' }}
                                                                            disabled={existDataListFlag}
                                                                            class="form-control" rows="3" placeholder="Type here..."></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div
                                                                class="d-flex align-items-center mt-4"
                                                                style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                                            >
                                                                <div className="d-flex">
                                                                    <div>
                                                                        <label>Operations Contact Name And Number<span class="mendatory_class">*</span></label>
                                                                        <textarea
                                                                            value={ExitOperationNameContact}
                                                                            disabled={existDataListFlag}
                                                                            onChange={(e) => this.setState({ ExitOperationNameContact: e.target.value })}
                                                                            style={{ resize: 'none', height: '100px' }}
                                                                            className="form-control"
                                                                            cols={100}
                                                                        />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div
                                                                class="d-flex align-items-center"
                                                                style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                                            >
                                                                <div className="d-flex">
                                                                    <div>
                                                                        <label>Operations Signature<span class="mendatory_class">*</span></label>
                                                                        <div
                                                                            class="client_signature_box"
                                                                            style={{ border: "1px solid #c9c8c8" }}
                                                                        >
                                                                            {oppIsSignatureSaved2 || existDataListFlag ? (
                                                                                <img
                                                                                    src={oppExitSignatureData}
                                                                                    style={{ width: 250, height: 125 }}
                                                                                    alt="Saved Signature"
                                                                                />
                                                                            ) : (

                                                                                <div>
                                                                                    <SignatureCanvas
                                                                                        ref={this.oppSignatureRef2}
                                                                                        penColor="rgb(126 123 123)"
                                                                                        canvasProps={{
                                                                                            width: 250,
                                                                                            height: 125,
                                                                                            className: "signature-canvas",
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        !existDataListFlag ?
                                                                            <div style={{ marginTop: "105px" }}>
                                                                                {oppIsSignatureSaveFlag2 || oppIsSignatureSaved2 ? (
                                                                                    <button
                                                                                        onClick={this.clearOppSaveSignatureImg2}
                                                                                        class="btn btn-secondary m-1"
                                                                                    >
                                                                                        Clear
                                                                                    </button>

                                                                                ) : (
                                                                                    <button
                                                                                        onClick={this.clearOppSignature2}
                                                                                        class="btn btn-secondary m-1"
                                                                                    >
                                                                                        Clear
                                                                                    </button>
                                                                                )}
                                                                                {oppIsSignatureSaveFlag2 || oppIsSignatureSaved2 ? (
                                                                                    <></>
                                                                                ) : (
                                                                                    <button
                                                                                        onClick={this.saveOppSignature2}
                                                                                        class="btn btn-success"
                                                                                    >
                                                                                        Save
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                            : <></>
                                                                    }
                                                                </div>


                                                                <div style={{ marginTop: "110px", display: existDataListFlag ? 'flex' : '', flexDirection: existDataListFlag ? 'column' : '' }} className="d-flex">
                                                                    {!existDataListFlag ?
                                                                        <>
                                                                            {exitSub ?
                                                                                <button
                                                                                    style={{ width: '100px' }}
                                                                                    class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                                                                >
                                                                                    Submit
                                                                                </button> :
                                                                                <>

                                                                                    <button
                                                                                        style={{ width: '100px' }}
                                                                                        class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                                                                        onClick={() => this.submitExitList(1, 'opp')}
                                                                                    >
                                                                                        Submit
                                                                                    </button>
                                                                                </>

                                                                            }
                                                                        </>
                                                                        : <>
                                                                            <span style={{ color: "#979797" }}>Exit Submitted by {ExitSubmittedUser}</span>
                                                                            <span style={{ color: "#979797" }}>{moment(ExitSubmittedDate).utc().format("DD/MM/YYYY hh:mm:ss")}</span>
                                                                        </>
                                                                    }
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                                : <></>
                        }
                        <div className="card-footer">
                            <div className="align-items-center gy-3">
                                <div className="row">
                                    <div className="col-md-12 text-left">
                                        <a
                                            href="javascript:void(0);"
                                            onClick={() => this.backToCheckList()}
                                            className="btn btn-warning my_custom_orderPage_btns m-2"
                                        >
                                            Back to List
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <ToastContainer />
                    <Modal
                        show={piSendShow}
                        // onHide={this.piModalClose}
                        size="lg"
                    >
                        <Modal.Header>
                            <Modal.Title>
                                Proforma Invoice for Order: {OrderNo}
                            </Modal.Title>

                        </Modal.Header>

                        <Modal.Body>
                            <div class="form-group">
                                {exitPiFilePath && (
                                    <iframe
                                        title="Proforma Invoice Report"
                                        src={exitPiFilePath}
                                        style={{
                                            width: "100%",
                                            height: "600px",
                                            border: "none",
                                        }}
                                    />
                                )}
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={() => this.setState({ piSendShow: false })}
                            >
                                close
                            </Button>
                            <Button
                                variant="success"
                                onClick={() => this.sendNewPi()}
                            >
                                Send PI
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            </>
        );
    }
}

export default withRouter(
    connect(null, {
        fill_action,
        download_exitPass_action,
        order_edit_details,
        client_detail_action,
        get_possession_list_action,
        get_exist_list_action,
        get_booking_Details_action,
        insert_possession_list_action,
        insert_exist_list_action,
        download_no_due_action, get_additional_services_action,
        update_additional_service_approval_action, send_new_pi_action
    })(CheckList_au)
);